// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/Figtree-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Arimo-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

/* Base Styles */
body,
.App {
  font-family: "Arimo-Regular", sans-serif;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.App {
  text-align: center;
}

/* ========================
   THEME STYLES
======================== */

/* Light Theme */
.light-theme {
  background-color: #eaecf0;
  color: #202020;
  font-family: "Arimo-Regular", sans-serif;
}

/* Dark Theme */
.dark-theme {
  background-color: #202020;
  color: #f0f0f0;
  font-family: "Arimo-Regular", sans-serif;
}

/* Utility text override */
.light-theme .text-muted {
  color: #475569 !important;
}

.dark-theme .text-muted {
  color: #ccc !important;
}

.dark-ckeditor .ck.ck-editor__editable:not(.ck-editor__nested-editable) {
  background-color: #1e1e1e;
  color: #fff;
}

/* ========================
   CARD STYLING
======================== */

.card,
.dataset-card,
.stat-card {
  transition: background-color 0.3s ease, color 0.3s ease;
}

/* Light Cards */
.light-theme .card,
.light-theme .dataset-card,
.light-theme .stat-card {
  background-color: #ffffff;
  color: #202020;
}

/* Dark Cards */
.dark-theme .card,
.dark-theme .dataset-card,
.dark-theme .stat-card {
  background-color: #2c2c2c;
  color: #f0f0f0;
}

/* ========================
   NAV TABS
======================== */

.custom-tab {
  background-color: transparent !important;
  border-radius: 30px 15px 0 0;
  padding: 10px 20px;
  font-weight: 500;
  color: #5f5d5d !important;
  transition: all 0.2s ease-in-out;
}

.custom-tab:hover {
  background-color: #c2c7cc;
  color: #000;
}

.active-tab {
  background-color: #233b7b !important;
  color: #fff !important;
  font-weight: bold;
  box-shadow: inset 4px 4px 10px rgba(0, 0, 0, 0.1);
}

.enq-tag-pill {
  text-transform: uppercase !important;
}

.dark-theme .custom-tab {
  background-color: #3a3a3a;
  color: #ccc;
}

.dark-theme .custom-tab:hover {
  background-color: #4a4a4a;
  color: white;
}

.custom-tab.active {
  background-color: #233b7b !important;
  color: #fff !important;
  font-weight: bold;
  box-shadow: inset 4px 4px 10px rgba(0, 0, 0, 0.1);
}

/* ========================
   DATASET CARDS
======================== */

.dataset-card {
  width: 100%;
  min-height: 200px;
  border-radius: 12px;
  padding: 10px;
  position: relative;
}

.dataset-card:hover {
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.bottom-image {
  position: absolute;
  bottom: 16px;
  right: 16px;
}

/* ========================
   STAT CARD
======================== */

.stat-card {
  border-radius: 10px;
  box-shadow: 8px 8px 16px #b0b4b9, -8px -8px 16px #ffffff;
}

.dark-theme .stat-card {
  box-shadow: none;
  border: 1px solid #444;
}

/* ========================
   ACTIVITY
======================== */

.activity-entry {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.activity-line {
  width: 4px;
  height: 36px;
  border-radius: 4px;
  margin-top: 2px;
}

.activity-line-orange {
  background-color: orange;
}

.activity-line-blue {
  background-color: #233b7b;
}

/* ========================
   CALENDAR ICON
======================== */

.calendar-icon-circle {
  background-color: #233b7b;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.calendar-icon {
  color: #f2f0ff;
  font-size: 16px;
}

/* ========================
   Theme-Based Table Support
======================== */

.table {
  transition: background-color 0.3s ease, color 0.3s ease;
}

.dark-theme .table {
  background-color: #2c2c2c;
  color: #f0f0f0;
}

.dark-theme .table thead {
  background-color: #3a3a3a;
  color: #ddd;
}

/* ========================
   Miscellaneous
======================== */

.text-orange {
  color: #f06700;
}

.btn-color {
  background-color: #233b7b !important;
}

.dark-field {
  background-color: #2c2c2c !important;
  border-color: #ccc !important;
}

.dark-placeholder::placeholder {
  color: #ccc !important;
  opacity: 1;
}

/* ========================
   Log In
======================== */

.login-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #1e3c72, #2a5298);
}

.login-card {
  display: flex;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  max-width: 700px;
  width: 100%;
}

.login-left {
  flex: 1 1;
  background-color: #e6e7ea;
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.login-left h4 {
  margin-bottom: 20px;
  font-size: 25px;
  color: #111827; /* the card stays light in both themes */
}

.login-input {
  margin-bottom: 20px;
  padding: 12px;
  border: none;
  border-radius: 5px;
  width: 100%;
  font-size: 16px;
  color: #111827;
  background-color: #ffffff;
}
.login-card .login-input::placeholder,
.dark-theme .login-card .login-input::placeholder { color: #4b5563 !important; }

.login-button {
  padding: 12px;
  border: none;
  border-radius: 5px;
  background-color: #052b81;
  color: white;
  font-weight: bold;
  cursor: pointer;
}

.login-button:hover {
  background-color: #003c94;
}

.login-right {
  flex: 1 1;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-right img {
  max-width: 100%;
  height: auto;
  padding: 5px;
}

.activity-line {
  width: 5px;
  height: 40px;
  border-radius: 5px;
  margin-right: 8px;
}

.activity-line-blue {
  background-color: #007bff;
}

.activity-line-green {
  background-color: #28a745;
}

.activity-line-orange {
  background-color: #e88316;
}

.activity-line-gray {
  background-color: #ccc;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.icon-hover-animate:hover {
  animation: bounceScale 0.6s ease-in-out;
}

@keyframes bounceScale {
  0% {
    transform: scale(1);
  }
  30% {
    transform: scale(1.3);
  }
  60% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}

.icon-animate {
  animation: bounceScale 0.6s ease-in-out;
}

.wave-emoji {
  display: inline-block;
  animation: wave 2s infinite;
  transform-origin: 70% 70%;
}

@keyframes wave {
  0% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(14deg);
  }
  20% {
    transform: rotate(-8deg);
  }
  30% {
    transform: rotate(14deg);
  }
  40% {
    transform: rotate(-4deg);
  }
  50% {
    transform: rotate(10deg);
  }
  60% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

@media (max-width: 576px) {
  .calendar-icon-circle {
    width: 35px;
    height: 35px;
  }

  .calendar-icon {
    font-size: 1rem;
  }

  .badge {
    font-size: 12px !important;
    padding: 6px 10px !important;
  }

  h3,
  h5 {
    font-size: 1.25rem;
  }

  .fw-bold {
    font-weight: 600 !important;
  }
}

::-webkit-scrollbar {
  height: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 3px;
}

.table-responsive-sm {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 768px) {
  .small-table-text {
    font-size: 12px;
  }

  .small-table-text th,
  .small-table-text td {
    padding: 6px 8px;
    font-size: 12px;
  }
}

.badge-circle {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: red;
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  z-index: 10;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.4);
}

/* ===== Enquiry Professional UI ===== */
.enq-page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-top: 10px;
  margin-bottom: 14px;
}

.enq-title {
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0.2px;
  margin-left: 10px;
}

.enq-subtitle {
  font-size: 16px;
  margin-top: 3px;
  margin-left: 10px;
}

.enq-header-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.enq-pill-btn {
  border-radius: 999px !important;
  padding: 8px 14px !important;
  font-weight: 600 !important;
}

.enq-stat-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 0;
  border-radius: 999px;
  padding: 8px 16px;
  font-weight: 600;
  background: rgba(26, 52, 131, 0.08);
  color: #1a3483;
  transition: background 0.15s ease;
}
.enq-stat-chip:hover {
  background: rgba(26, 52, 131, 0.14);
}
.enq-stat-chip strong {
  background: #1a3483;
  color: #fff;
  border-radius: 999px;
  padding: 2px 10px;
  font-weight: 800;
  font-size: 13px;
}
.dark-theme .enq-stat-chip {
  background: rgba(255, 255, 255, 0.08);
  color: #e5e7eb;
}
.dark-theme .enq-stat-chip:hover {
  background: rgba(255, 255, 255, 0.14);
}

.enq-template-toggle {
  border-radius: 999px !important;
  padding: 8px 14px !important;
  font-weight: 600 !important;
  border: 1px solid;
  background-color: transparent;
  display: flex !important;
  align-items: center;
  flex-wrap: nowrap !important;
  gap: 10px;
  white-space: nowrap;
  overflow: hidden;
}

.enq-template-toggle-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.enq-template-toggle-chips {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
}

.enq-template-toggle-placeholder {
  font-size: 12px;
  font-weight: 500;
  opacity: 1;
  color: #4b5563;
}
.dark-theme .enq-template-toggle-placeholder { color: #b6bcc6; }

.enq-template-chip {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}
.enq-template-chip.email {
  background: rgba(26, 52, 131, 0.12);
  color: #1a3483;
}
.enq-template-chip.whatsapp {
  background: rgba(37, 211, 102, 0.16);
  color: #128c4a;
}
.dark-theme .enq-template-chip.email {
  background: rgba(147, 197, 253, 0.18);
  color: #93c5fd;
}
.dark-theme .enq-template-chip.whatsapp {
  background: rgba(74, 222, 128, 0.18);
  color: #4ade80;
}

.enq-template-tabs {
  display: flex;
  gap: 6px;
}

.enq-template-tab {
  flex: 1 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 999px;
  padding: 9px 10px;
  font-size: 13px;
  font-weight: 700;
  background: rgba(0, 0, 0, 0.05);
  color: #4b5563;
  transition: background 0.15s ease, color 0.15s ease;
}
.bg-dark .enq-template-tab {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.72);
}

.enq-template-tab-email.active {
  background: #1a3483;
  color: #fff;
}
.enq-template-tab-whatsapp.active {
  background: #25d366;
  color: #fff;
}

.enq-template-list {
  max-height: 260px;
  overflow-y: auto;
}

.enq-template-list-modal {
  max-height: 340px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.enq-template-row {
  display: flex;
  align-items: center;
  width: 100%;
  text-align: left;
  border: 0;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 600;
  background: transparent;
  color: inherit;
  transition: background 0.15s ease;
}
.enq-template-row:hover {
  background: rgba(0, 0, 0, 0.05);
}
.bg-dark .enq-template-row:hover {
  background: rgba(255, 255, 255, 0.08);
}
.enq-template-row.active {
  background: rgba(26, 52, 131, 0.1);
  color: #1a3483;
}
.bg-dark .enq-template-row.active {
  background: rgba(147, 197, 253, 0.15);
  color: #93c5fd;
}

.enq-template-empty {
  padding: 8px 16px;
  font-size: 13px;
  color: #475569;
}

.enq-card {
  border-radius: 14px !important;
  border: 1px solid rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.enq-actions-row {
  display: flex;
  gap: 12px;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid rgba(0, 0, 0, 0.07);
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.dark-theme .enq-actions-row {
  border-top-color: rgba(255, 255, 255, 0.1);
}

.enq-toolbar-divider {
  width: 1px;
  height: 22px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 2px;
}
.dark-theme .enq-toolbar-divider {
  background: rgba(255, 255, 255, 0.14);
}

.enq-left-actions,
.enq-right-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
}

.enq-action-btn {
  border-radius: 12px !important;
  padding: 8px 12px !important;
  font-weight: 600 !important;
}

.enq-filters .btn {
  border-radius: 999px !important;
  font-weight: 700;
}

.enq-filter-btn.active {
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

.enq-badge {
  border-radius: 999px !important;
  font-weight: 800 !important;
}

/* Calm "not linked yet / can't load" state for the WhatsApp Conversation
   panel — deliberately not styled as a red/danger error, since this is a
   normal, expected wait rather than something wrong. */
.enq-wa-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  padding: 28px 16px;
  border-radius: 14px;
  background: rgba(13, 110, 253, 0.05);
  border: 1px dashed rgba(13, 110, 253, 0.2);
}
.enq-wa-empty.dark {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.15);
}
.enq-wa-empty-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  background: rgba(13, 110, 253, 0.12);
  color: #0d6efd;
}
.enq-wa-empty.dark .enq-wa-empty-icon {
  background: rgba(255, 255, 255, 0.1);
  color: #8ab4ff;
}
.enq-wa-empty-text {
  font-size: 13.5px;
  color: #5b6472;
  max-width: 300px;
  line-height: 1.5;
  text-wrap: balance;
}
.enq-wa-empty.dark .enq-wa-empty-text {
  color: rgba(255, 255, 255, 0.72);
}

.enq-wa-template-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.enq-wa-template-icon {
  position: absolute;
  left: 14px;
  font-size: 13px;
  color: #475569;
  pointer-events: none;
}
.dark-theme .enq-wa-template-icon {
  color: rgba(255, 255, 255, 0.72);
}

.enq-wa-template-select {
  border-radius: 999px !important;
  padding: 8px 14px 8px 36px !important;
  font-size: 13px;
  font-weight: 600;
  border-color: rgba(0, 0, 0, 0.12) !important;
}
.dark-theme .enq-wa-template-select {
  border-color: rgba(255, 255, 255, 0.16) !important;
}

.enq-wa-composer {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 18px;
  background: #ffffff;
  padding: 6px 6px 6px 10px;
}
.enq-wa-composer.dark {
  background: #232427;
  border-color: rgba(255, 255, 255, 0.14);
}
.enq-wa-composer:focus-within {
  border-color: #25d366;
  box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.15);
}

.enq-wa-attach-btn {
  border: 0;
  background: transparent;
  color: #475569;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-bottom: 3px;
  transition: background 0.15s ease;
}
.enq-wa-composer.dark .enq-wa-attach-btn {
  color: rgba(255, 255, 255, 0.72);
}
.enq-wa-attach-btn:hover {
  background: rgba(0, 0, 0, 0.06);
}
.enq-wa-composer.dark .enq-wa-attach-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}
.enq-wa-attach-btn:disabled {
  opacity: 1;
  cursor: not-allowed;
}

.enq-wa-textarea.form-control {
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  padding: 6px 4px !important;
  resize: none;
}
.enq-wa-textarea.form-control:focus {
  box-shadow: none !important;
}

.enq-wa-send-btn {
  border: 0;
  background: #25d366;
  color: #fff;
  width: 36px;
  height: 36px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.15s ease, transform 0.1s ease;
}
.enq-wa-send-btn:hover:not(:disabled) {
  background: #1fb857;
  transform: scale(1.05);
}
.enq-wa-send-btn:disabled {
  background: #475569;
  cursor: not-allowed;
}

.enq-table {
  font-size: 15px;
  width: 100%;
  border-collapse: collapse;
}

.enq-thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f8f9fa;
  border-bottom: 1px solid rgba(0,0,0,0.08) !important;
  font-weight: 800;
}

.table-dark .enq-thead th {
  background: #1f1f1f !important;
  border-bottom: 1px solid rgba(255,255,255,0.12) !important;
}

.enq-checkbox .form-check-input {
  width: 20px;
  height: 20px;
  border: 2px solid #6b7280;
  cursor: pointer;
  box-shadow: none;
}
.enq-checkbox .form-check-input:checked {
  background-color: #1a3483;
  border-color: #1a3483;
}
.enq-checkbox .form-check-input:focus {
  border-color: #1a3483;
  box-shadow: 0 0 0 3px rgba(26, 52, 131, 0.25);
}
.table-dark .enq-checkbox .form-check-input,
.dark-theme .enq-checkbox .form-check-input {
  border-color: rgba(255, 255, 255, 0.65);
  background-color: rgba(255, 255, 255, 0.08);
}
.table-dark .enq-checkbox .form-check-input:checked,
.dark-theme .enq-checkbox .form-check-input:checked {
  background-color: #3987e5;
  border-color: #3987e5;
}

.enq-email {
  font-weight: 600;
}

.enq-chip {
  color: #fff;
  font-weight: 800;
  font-size: 12px;
  padding: 6px 10px;
  border-radius: 999px;
  display: inline-block;
  text-transform: capitalize;
}

.enq-action-icons {
  display: flex;
  gap: 6px;
  align-items: center;
}

.enq-icon-btn {
  border: 1px solid rgba(0,0,0,0.08);
  background: rgba(0,0,0,0.02);
  border-radius: 10px;
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all .15s ease;
}

.table-dark .enq-icon-btn {
  border: 1px solid rgba(255,255,255,0.12);
  background: rgba(255,255,255,0.04);
  color: #fff;
}

.enq-icon-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 16px rgba(0,0,0,0.10);
}

.enq-icon-btn.danger {
  color: #dc3545;
}
.table-dark .enq-icon-btn.danger {
  color: #f1a3ab;
}

.enq-icon-btn.danger:hover {
  border-color: rgba(220, 53, 69, 0.35);
  background: rgba(220, 53, 69, 0.08);
}

/* New WhatsApp message badge, pinned above the View (eye) icon */
.enq-icon-btn-wrap {
  position: relative;
  display: inline-flex;
}
.enq-new-message-badge {
  position: absolute;
  top: -9px;
  right: -8px;
  background: #25d366;
  color: #073b1e;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.3px;
  line-height: 1;
  padding: 3px 5px;
  border-radius: 999px;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(37, 211, 102, 0.5);
  z-index: 2;
  pointer-events: none;
  animation: enq-new-message-pulse 1.6s ease-in-out infinite;
}
@keyframes enq-new-message-pulse {
  0%, 100% { box-shadow: 0 2px 8px rgba(37, 211, 102, 0.5); }
  50% { box-shadow: 0 2px 8px rgba(37, 211, 102, 0.9), 0 0 0 3px rgba(37, 211, 102, 0.18); }
}

.enq-empty-title {
  font-size: 16px;
  font-weight: 900;
  margin-bottom: 6px;
}

/* Top Menu */
/* ===== TMIS Topbar (Professional) ===== */
.tmis-topbar {
  background: #ffffff;
  border-bottom: 1px solid rgba(16, 24, 40, 0.08);
  box-shadow: 0 6px 20px rgba(16, 24, 40, 0.06);
  border-radius: 14px;
  margin: 14px 0;
}

.tmis-topbar--dark {
  background: #292a32;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);
}

.tmis-logo {
  height: 40px;
  width: auto;
  object-fit: contain;
}

.tmis-brand-title {
  font-weight: 800;
  letter-spacing: 0.2px;
  line-height: 1.05;
}

.tmis-brand-sub {
  font-size: 12px;
  margin-top: 2px;
}

.tmis-badge-soft {
  font-size: 12px;
  padding: 6px 8px;
  border-radius: 999px;
}

/* Icon Buttons */
.tmis-icon-btn {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(16, 24, 40, 0.04) !important;
  color: #233b7b !important;
  border: 1px solid rgba(16, 24, 40, 0.06) !important;
  transition: all 0.18s ease;
}

.tmis-icon-btn:hover {
  transform: translateY(-1px);
  background: rgba(35, 59, 123, 0.10) !important;
}

.tmis-icon-btn--dark {
  background: rgba(255, 255, 255, 0.06) !important;
  color: #fff !important;
  border: 1px solid rgba(255, 255, 255, 0.10) !important;
}

.tmis-icon-btn--danger {
  background: rgba(220, 53, 69, 0.10) !important;
  color: #dc3545 !important;
  border: 1px solid rgba(220, 53, 69, 0.20) !important;
}

.tmis-icon-btn--danger:hover {
  background: rgba(220, 53, 69, 0.18) !important;
}

/* Offcanvas */
.tmis-offcanvas-dark {
  background: #121723 !important;
}

.tmis-drawer-link {
  border-radius: 12px;
  padding: 10px 12px !important;
  font-weight: 700;
  color: #1f2a44 !important;
  background: rgba(16, 24, 40, 0.04);
}

.tmis-drawer-link:hover {
  background: rgba(35, 59, 123, 0.10);
}

.tmis-drawer-link--dark {
  color: #fff !important;
  background: rgba(255, 255, 255, 0.06);
}

.tmis-drawer-link--dark:hover {
  background: rgba(255, 255, 255, 0.10);
}

/* ===== Shell ===== */
.tmis-shell {
  min-height: 100vh;
  padding: 18px;
  background: #f5f7fb;
}
.tmis-shell.dark {
  background: #0f1220;
}

/* ===== Topbar ===== */
.tmis-topbar {
  border-radius: 14px;
  padding: 10px 6px;
  box-shadow: 0 8px 18px rgba(0,0,0,0.06);
  border: 1px solid rgba(0,0,0,0.06);
}
.tmis-topbar.light { background: #ffffff; }
.tmis-topbar.dark {
  background: #14182a;
  border-color: rgba(255,255,255,0.06);
}
.tmis-brand-logo { height: 34px; width: auto; }

.tmis-navlink {
  border-radius: 999px;
  padding: 10px 14px !important;
  font-weight: 600;
  color: #1f2a37 !important;
}
.tmis-navlink.dark { color: #e5e7eb !important; }
.tmis-navlink:hover { background: rgba(59,130,246,0.08); }
.tmis-navlink.active {
  background: rgba(59,130,246,0.14);
  color: #0b5ed7 !important;
}
.tmis-navlink.active.dark { color: #93c5fd !important; }

.tmis-nav-divider {
  width: 1px;
  height: 26px;
  background: rgba(0,0,0,0.12);
  margin: 0 6px;
}
.tmis-topbar.dark .tmis-nav-divider { background: rgba(255,255,255,0.14); }

.tmis-pillbtn {
  border-radius: 999px !important;
  padding: 10px 14px !important;
  font-weight: 700 !important;
}
.tmis-iconbtn {
  width: 40px;
  height: 40px;
  border-radius: 999px !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* ===== Hero ===== */
.tmis-hero {
  border: 0;
  border-radius: 14px;
  overflow: hidden;
}

.tmis-hero.dark {
  background: #2a2b2c;
}
.tmis-hero-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 18px 18px;
}
.tmis-hero-left { min-width: 0; }
.tmis-hero-kicker { font-weight: 700; color: #222223; }
.tmis-hero.dark .tmis-hero-kicker { color: #e5e7eb; }
.tmis-hero-title {
  font-size: 26px;
  font-weight: 800;
  line-height: 1.15;
  margin-top: 5px;
  color: #222223;
}
.tmis-hero.dark .tmis-hero-title { color: #ffffff; }
.tmis-hero-subtitle {
  margin-top: 10px;
  color: #393939;
  font-weight: 500;
  font-size: 14px;
}
.tmis-hero.dark .tmis-hero-subtitle { color: rgba(255, 255, 255, 0.72); }

.tmis-clock {
  background: rgba(255,255,255,0.8);
  border: 1px solid rgba(0,0,0,0.06);
  border-radius: 14px;
  padding: 10px 12px;
  min-width: 160px;
  text-align: right;
}
.tmis-clock.dark {
  background: rgba(0,0,0,0.22);
  border-color: rgba(255,255,255,0.08);
}
.tmis-clock-date { font-size: 12px; color: #475569; font-weight: 700; }
.tmis-clock.dark .tmis-clock-date { color: rgba(255, 255, 255, 0.72); }
.tmis-clock-time { font-size: 18px; font-weight: 900; color: #0f172a; }
.tmis-clock.dark .tmis-clock-time { color: #fff; }

/* ===== Stat Cards ===== */
.tmis-stats-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 14px;
  align-items: stretch;
}
@media (max-width: 1199px) {
  .tmis-stats-grid { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 767px) {
  .tmis-stats-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 480px) {
  .tmis-stats-grid { grid-template-columns: 1fr; }
}

.tmis-stat {
  position: relative;
  width: 100%;
  border: 0;
  border-radius: 14px;
  box-shadow: 0 10px 20px rgba(0,0,0,0.08);
  background: #ffffff;
  border-top: 4px solid var(--tmis-accent, #1a3483);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
  overflow: hidden;
}
.tmis-stat:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 26px rgba(0,0,0,0.12);
}
.tmis-stat.dark { background: #2a2b2c; }

.tmis-stat-body {
  position: relative;
  z-index: 1;
  padding: 14px;
}

.tmis-stat-top {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  min-width: 0;
}

/* Big decorative icon, half-clipped off the card's right edge - identity
   watermark rather than a functional element (pointer-events off, low
   opacity, sits behind the text). */
.tmis-stat-icon-bg {
  position: absolute;
  top: 40%;
  right: -30px;
  transform: translateY(-50%);
  font-size: 100px;
  line-height: 1;
  color: var(--tmis-accent, #1a3483);
  opacity: 0.14;
  z-index: 0;
  pointer-events: none;
}
.tmis-stat.dark .tmis-stat-icon-bg {
  color: var(--tmis-accent-dark, #93c5fd);
  opacity: 0.16;
}

.tmis-stat-title {
  font-weight: 800;
  font-size: 13px;
  color: #111827;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
}
.tmis-stat.dark .tmis-stat-title { color: #fff; }

/* Per-card accent, assigned in a fixed order so each channel keeps a
   consistent identity across the dashboard. */
/* Shared identity palette (reused by Dashboard stat cards, Kanban columns,
   and anywhere else that needs a fixed-order categorical accent). */
.accent-blue    { --tmis-accent: #1a3483; --tmis-accent-tint: #e6ebf8; --tmis-accent-dark: #3987e5; --tmis-accent-dark-text: #9dc3f4; }
.accent-violet  { --tmis-accent: #653b9e; --tmis-accent-tint: #efe7fa; --tmis-accent-dark: #7c3aed; --tmis-accent-dark-text: #c8b7f7; }
.accent-teal    { --tmis-accent: #0a5d5c; --tmis-accent-tint: #e2f4f2; --tmis-accent-dark: #199e70; --tmis-accent-dark-text: #2ed99e; }
.accent-green   { --tmis-accent: #0a5f34; --tmis-accent-tint: #e2f6ea; --tmis-accent-dark: #4ade80; --tmis-accent-dark-text: #5ee38f; }
.accent-magenta { --tmis-accent: #9c1f55; --tmis-accent-tint: #fbe7ef; --tmis-accent-dark: #d55181; --tmis-accent-dark-text: #edb1c9; }
.accent-slate   { --tmis-accent: #475569; --tmis-accent-tint: #eceff3; --tmis-accent-dark: #94a3b8; --tmis-accent-dark-text: #bbc8d2; }

.tmis-stat-hero { margin-bottom: 10px; }
.tmis-stat-hero-label {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #475569;
}
.tmis-stat.dark .tmis-stat-hero-label { color: rgba(255, 255, 255, 0.72); }

.tmis-stat-hero-value {
  font-size: 30px;
  font-weight: 850;
  line-height: 1.15;
  color: #111827;
}
.tmis-stat.dark .tmis-stat-hero-value { color: #fff; }
.tmis-stat-hero-value.tmis-hero-red { color: #b22222; }
.tmis-stat.dark .tmis-stat-hero-value.tmis-hero-red { color: #fca5a5; }

.tmis-stat-foot {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  font-size: 12px;
  color: #475569;
  border-top: 1px solid rgba(0,0,0,0.06);
  padding-top: 8px;
}
.tmis-stat.dark .tmis-stat-foot {
  color: rgba(255, 255, 255, 0.72);
  border-top-color: rgba(255,255,255,0.1);
}
.tmis-stat-foot strong { color: #111827; font-weight: 800; }
.tmis-stat.dark .tmis-stat-foot strong { color: #fff; }
.tmis-stat-foot strong.tmis-foot-green { color: #0d602d; }
.tmis-stat.dark .tmis-stat-foot strong.tmis-foot-green { color: #4ade80; }

.tmis-mini-pill {
  border-radius: 999px;
  padding: 6px 10px;
  font-weight: 800;
  border: 0;
}
.tmis-mini-pill.responded { background: #0d6e39; }
.tmis-mini-pill.pending { background: #b02a37; }

/* ===== Section Head ===== */
.tmis-section-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  margin-top: 4px;
}
.tmis-section-title {
  font-weight: 900;
  font-size: 16px;
  color: #0f172a;
}
.tmis-section-title.dark { color: #fff; }
.tmis-section-sub { font-size: 13px; color: #544c47 !important; }

.tmis-count-pill {
  border-radius: 999px;
  padding: 10px 14px;
  font-weight: 900;
  background: #ffedd5;
  color: #c2410c;
}

.tmis-enq-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 999px; /* pill */
  font-size: 13px;
  font-weight: 600;
  color: #0f5132;                /* dark green text */
  background: #e6f4ea;           /* soft green */
  border: 1px solid #b7e1c1;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

/* ===== Table Card ===== */
.tmis-tablecard {
  border: 0;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 10px 20px rgba(0,0,0,0.08);
}
.tmis-tablecard.dark { background: #14182a; }
.tmis-tablecard table thead th {
  font-size: 14px;
  letter-spacing: .04em;
}
.tmis-tablecard table  td {
  font-size: 14px !important;
}
.tmis-ellipsis {
  max-width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ===== Status Pills ===== */
.tmis-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  padding: 6px 12px;
  font-weight: 800;
  font-size: 12px;
  color: #fff;
}

/* ===== Activities Panel ===== */
.tmis-activities {
  width: 100%;
  border: 0;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 10px 20px rgba(0,0,0,0.08);
  background: #ffffff;
}
.tmis-activities.dark { background: #2a2b2c; }

.tmis-activities-head {
  position: sticky;
  top: 0;
  z-index: 5;
  background: #ffffff;
  border-bottom: 1px solid rgba(0,0,0,0.06);
  padding: 12px 14px;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap: 10px;
}
.tmis-activities-head.dark {
  background: #2e2e2e;
  border-bottom-color: rgba(255,255,255,0.08);
}
.tmis-activities-title { font-weight: 900; }

.tmis-activities-body {
  padding: 12px 12px;
  max-height: calc(100vh - 210px);
  overflow: auto;
}

.tmis-compact-select {
  border-radius: 10px;
  font-weight: 800;
}
.tmis-compact-select.dark {
  background: rgba(255,255,255,0.06);
  color: #fff;
  border-color: rgba(255,255,255,0.10);
}
/* The dropdown's option list is a separate native popup that doesn't
   inherit the select's translucent background - style it explicitly with
   an opaque dark background, or the (inherited) white text is invisible. */
.tmis-compact-select.dark option {
  background-color: #2a2b2c;
  color: #fff;
}

.tmis-circle-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #eef2ff;
  display:flex;
  align-items:center;
  justify-content:center;
  color: #1d4ed8;
}
.tmis-activities.dark .tmis-circle-icon {
  background: rgba(255,255,255,0.08);
  color: #93c5fd;
}

.tmis-date-sep {
  font-weight: 900;
  font-size: 12px;
  color: #475569;
  margin: 8px 2px 10px;
}
.tmis-date-sep.dark { color: rgba(255, 255, 255, 0.72); }

.tmis-activity-card {
  position: relative;
  border-radius: 14px;
  padding: 12px 12px;
  background: #f8fafc;
  border-left: 6px solid #f59e0b;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 10px;
  overflow: hidden;
  margin-bottom: 10px;
}
.tmis-activity-card.dark { background: rgba(255,255,255,0.06); }

.tmis-activity-decor {
  position: absolute;
  right: -18px;
  bottom: -18px;
  width: 110px;
  opacity: 0.25;
  pointer-events: none;
}

.tmis-activity-main { position: relative; z-index: 2; min-width: 0; }
.tmis-activity-name { font-weight: 900; margin-bottom: 6px; }
.tmis-activity-row { display:flex; align-items:center; font-size: 12px; margin-top: 2px; }
.tmis-activity-muted { color: #475569; font-weight: 700; }
.tmis-activity-card.dark .tmis-activity-muted { color: rgba(255, 255, 255, 0.72); }

.tmis-activity-stamp {
  position: relative;
  z-index: 2;
  min-width: 54px;
  display:flex;
  align-items:center;
  justify-content:center;
  background: rgba(0,0,0,0.03);
  border-radius: 12px;
}
.tmis-activity-card.dark .tmis-activity-stamp { background: rgba(255,255,255,0.06); }

.tmis-checkmark {
  font-weight: 900;
  font-size: 26px;
  color: rgba(31,41,55,0.20);
}
.tmis-activity-card.dark .tmis-checkmark { color: rgba(255, 255, 255, 0.72); }

.tmis-empty { text-align:center; padding: 30px 10px; }
.tmis-empty-img { width: 120px; opacity: .9; }

/* Responsive tweak */
@media (max-width: 991px) {
  .tmis-activities-body { max-height: 520px; }
}

/* ---------- Tablet ---------- */
@media (max-width: 991px) {
  .hide-md {
    display: none;
  }
}

/* ---------- Mobile ---------- */
@media (max-width: 767px) {
  .enq-table thead {
    display: none;
  }

  .enq-table,
  .enq-table tbody,
  .enq-table tr,
  .enq-table td {
    display: block;
    width: 100%;
  }

  .enq-table tr {
    background: #fff;
    border-radius: 12px;
    margin-bottom: 14px;
    padding: 12px;
    box-shadow: 0 6px 16px rgba(0,0,0,.08);
  }

  .enq-table td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 0;
    border: none;
    font-size: 14px;
  }

  .enq-table td::before {
    content: attr(data-label);
    font-weight: 600;
    color: #666;
  }

  .hide-lg {
    display: none;
  }
}
/* ---------- Tablet: hide some columns to fit width ---------- */
@media (max-width: 991px) {
  .tmis-hide-md {
    display: none !important;
  }
}

/* ---------- Small tablet/large phone: hide more ---------- */
@media (max-width: 767px) {
  .tmis-hide-lg {
    display: none !important;
  }

  /* Hide header, convert rows into cards */
  .tmis-table-responsive thead {
    display: none;
  }

  .tmis-table-responsive,
  .tmis-table-responsive tbody,
  .tmis-table-responsive tr,
  .tmis-table-responsive td {
    display: block;
    width: 100%;
  }

  .tmis-table-responsive tr.tmis-row {
    border-radius: 14px;
    margin: 12px 0;
    padding: 12px 12px 8px;
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(0, 0, 0, 0.06);
  }

  /* Dark mode card borders */
  .table-dark tr.tmis-row {
    border: 1px solid rgba(255, 255, 255, 0.12);
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.25);
  }

  .tmis-table-responsive td {
    display: flex;
    justify-content: space-between;
    gap: 14px;
    padding: 8px 0;
    border: 0 !important;
    white-space: normal;
  }

  .tmis-table-responsive td::before {
    content: attr(data-label);
    font-weight: 700;
    min-width: 92px;
  }

  /* Keep status pill aligned nicely */
  .tmis-table-responsive td[data-label="Status"] {
    align-items: center;
  }

  /* Optional: make first two fields stronger */
  .tmis-table-responsive td[data-label="Name"] {
    font-weight: 700;
  }
}

/* ===== Data Center ===== */
.dc-sidebar {
  border-radius: 18px;
  border: 0;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
  padding: 12px;
}

.dc-nav-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 12px;
  border-radius: 14px;
  border: 0;
  background: transparent;
  text-align: left;
  font-weight: 700;
  font-size: 14px;
  color: #374151;
  transition: background 0.15s ease, color 0.15s ease;
}
.dark-theme .dc-nav-item { color: rgba(255,255,255,0.75); }

.dc-nav-item:hover {
  background: rgba(0,0,0,0.04);
}
.dark-theme .dc-nav-item:hover {
  background: rgba(255,255,255,0.06);
}

.dc-nav-item.active {
  background: var(--tmis-accent-tint, #eef2ff);
  color: var(--tmis-accent, #1a3483);
}
.dark-theme .dc-nav-item.active {
  background: rgba(255,255,255,0.09);
  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));
}

.dc-nav-icon {
  width: 36px;
  height: 36px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  flex-shrink: 0;
  background: rgba(0,0,0,0.05);
  color: #475569;
}
.dark-theme .dc-nav-icon { background: rgba(255,255,255,0.08); color: rgba(255, 255, 255, 0.72); }

.dc-nav-item.active .dc-nav-icon {
  background: var(--tmis-accent, #1a3483);
  color: #fff;
}

.dc-nav-label { flex: 1 1; line-height: 1.25; }

.dc-nav-count {
  min-width: 24px;
  height: 22px;
  padding: 0 7px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.06);
  color: #374151;
}
.dark-theme .dc-nav-count { background: rgba(255,255,255,0.1); color: rgba(255,255,255,0.75); }

.dc-nav-item.active .dc-nav-count {
  background: var(--tmis-accent, #1a3483);
  color: #fff;
}

.dc-table-card {
  border-radius: 18px !important;
  border: 0 !important;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
}

.dc-color-chip {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 4px 10px 4px 6px;
  border-radius: 999px;
  background: rgba(0,0,0,0.04);
  font-size: 12px;
  font-weight: 700;
  color: #374151;
}
.dark-theme .dc-color-chip { background: rgba(255,255,255,0.07); color: rgba(255,255,255,0.75); }

.dc-color-dot {
  width: 14px;
  height: 14px;
  border-radius: 999px;
  flex-shrink: 0;
  border: 1px solid rgba(0,0,0,0.12);
}
.dark-theme .dc-color-dot { border-color: rgba(255,255,255,0.25); }

.dc-swatch-btn {
  width: 24px;
  height: 24px;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid rgba(0,0,0,0.15);
  transition: transform 0.1s ease;
}
.dc-swatch-btn:hover { transform: scale(1.1); }
.dc-swatch-btn.selected {
  outline: 2px solid var(--tmis-accent, #1a3483);
  outline-offset: 2px;
}

/* ===== Total Counts sidebar ===== */
.enq-count-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 16px;
}

.enq-count-stat {
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 16px;
  padding: 14px;
  background: #fff;
  border: 1px solid rgba(0,0,0,0.06);
  box-shadow: 0 8px 20px rgba(15,23,42,0.06);
}
.dark-theme .enq-count-stat {
  background: #232427;
  border-color: rgba(255,255,255,0.1);
}

.enq-count-stat-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  background: var(--tmis-accent-tint, #eef2ff);
  color: var(--tmis-accent, #1a3483);
}
.dark-theme .enq-count-stat-icon {
  background: rgba(255,255,255,0.08);
  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));
}

.enq-count-stat-value {
  font-size: 24px;
  font-weight: 850;
  line-height: 1.1;
}

.enq-count-stat-label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  margin-top: 2px;
}
.dark-theme .enq-count-stat-label {
  color: rgba(255, 255, 255, 0.72);
}

.enq-count-tabs {
  display: flex;
  gap: 6px;
  padding: 4px;
  border-radius: 999px;
  background: rgba(0,0,0,0.05);
  margin-bottom: 14px;
}
.dark-theme .enq-count-tabs {
  background: rgba(255,255,255,0.06);
}

.enq-count-tab {
  flex: 1 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 0;
  border-radius: 999px;
  padding: 9px 12px;
  font-weight: 700;
  font-size: 14px;
  background: transparent;
  color: #4b5563;
  transition: background 0.15s ease, color 0.15s ease;
}
.dark-theme .enq-count-tab {
  color: rgba(255, 255, 255, 0.72);
}
.enq-count-tab.active {
  background: #1a3483;
  color: #fff;
  box-shadow: 0 6px 14px rgba(26,52,131,0.3);
}

.enq-count-tab-badge {
  background: rgba(0,0,0,0.08);
  border-radius: 999px;
  padding: 1px 8px;
  font-size: 12px;
  font-weight: 800;
}
.enq-count-tab.active .enq-count-tab-badge {
  background: rgba(255,255,255,0.25);
  color: #fff;
}
.dark-theme .enq-count-tab-badge {
  background: rgba(255,255,255,0.12);
  color: #e5e7eb;
}

.enq-count-hint {
  font-size: 12.5px;
  color: #475569;
  margin-bottom: 10px;
}
.dark-theme .enq-count-hint {
  color: rgba(255, 255, 255, 0.72);
}

.enq-count-clear {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: rgba(220,53,69,0.1);
  color: #dc3545;
  font-size: 12.5px;
  font-weight: 700;
  border-radius: 999px;
  padding: 5px 12px;
  margin-bottom: 12px;
}
.enq-count-clear:hover {
  background: rgba(220,53,69,0.18);
}

.enq-count-item {
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 16px;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid rgba(0,0,0,0.06);
  border-left: 4px solid transparent;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease, border-color 0.15s ease;
}
.dark-theme .enq-count-item {
  background: #232427;
  border-color: rgba(255,255,255,0.08);
  border-left-color: transparent;
}
.enq-count-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 20px rgba(15,23,42,0.1);
}
.enq-count-item.selected {
  background: rgba(26,52,131,0.05);
  border-left-color: var(--item-color, #1a3483);
}
.dark-theme .enq-count-item.selected {
  background: rgba(255,255,255,0.06);
}

.enq-count-item-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.enq-count-item-info {
  flex: 1 1;
  min-width: 0;
}

.enq-count-item-name {
  font-weight: 700;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.enq-count-item-type {
  font-size: 12px;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  font-weight: 700;
}

.enq-count-item-value {
  text-align: right;
  flex-shrink: 0;
}

.enq-count-item-number {
  font-size: 20px;
  font-weight: 850;
  line-height: 1.1;
}

.enq-count-item-suffix {
  font-size: 12px;
  color: #475569;
}

.enq-count-item-check {
  flex-shrink: 0;
  color: var(--item-color, #1a3483);
  font-size: 14px;
}

/* ===== Data Center: Privacy & Security ===== */
.dc-privacy-eyebrow {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--tmis-accent, #0a5f34);
  margin-bottom: 14px;
}
.dark-theme .dc-privacy-eyebrow { color: var(--tmis-accent-dark-text, var(--tmis-accent-dark)); }

.dc-privacy-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 18px 20px;
  border-radius: 16px;
  background: rgba(18, 140, 74, 0.05);
  border: 1px solid rgba(18, 140, 74, 0.18);
}
.dark-theme .dc-privacy-row {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.12);
}
.dc-privacy-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}
.dc-privacy-title { font-size: 18px; font-weight: 800; }
.dc-privacy-descs { margin: 0; padding-left: 20px; }
.dc-privacy-desc { font-size: 14px; line-height: 1.6; }

.dc-switch {
  position: relative;
  flex-shrink: 0;
  width: 84px;
  height: 38px;
  border: 0;
  border-radius: 999px;
  background: #475569;
  color: #fff;
  cursor: pointer;
  transition: background 0.2s ease, opacity 0.2s ease;
}
.dc-switch.on { background: #0c6b37; }
.dc-switch:disabled { cursor: progress; }
.dc-switch:focus-visible { outline: 3px solid rgba(18, 140, 74, 0.35); outline-offset: 2px; }
.dc-switch-label {
  position: absolute;
  top: 50%;
  right: 14px;
  transform: translateY(-50%);
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.5px;
}
.dc-switch.on .dc-switch-label { right: auto; left: 14px; }
.dc-switch-knob {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease;
}
.dc-switch.on .dc-switch-knob { transform: translateX(46px); }

/* ===== Dark mode: page selector (Enquiries + Dashboard) =====
   Bootstrap's pagination is white with blue links by default, which glares
   on the dark table above it. Bootstrap 5.3 drives it entirely from these
   variables, so redefining them restyles every page item at once. */
.dark-theme .pagination {
  --bs-pagination-color: #e5e7eb;
  --bs-pagination-bg: #2a2d31;
  --bs-pagination-border-color: rgba(255, 255, 255, 0.14);
  --bs-pagination-hover-color: #fff;
  --bs-pagination-hover-bg: #3a3f46;
  --bs-pagination-hover-border-color: rgba(255, 255, 255, 0.22);
  --bs-pagination-focus-color: #fff;
  --bs-pagination-focus-bg: #3a3f46;
  --bs-pagination-focus-box-shadow: 0 0 0 0.2rem rgba(57, 135, 229, 0.35);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #2f6fd6;
  --bs-pagination-active-border-color: #2f6fd6;
  --bs-pagination-disabled-color: rgba(255, 255, 255, 0.35);
  --bs-pagination-disabled-bg: #232528;
  --bs-pagination-disabled-border-color: rgba(255, 255, 255, 0.08);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,+DAAwD;EACxD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;;EAEE,wCAAwC;EACxC,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;0BAE0B;;AAE1B,gBAAgB;AAChB;EACE,yBAAyB;EACzB,cAAc;EACd,wCAAwC;AAC1C;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,cAAc;EACd,wCAAwC;AAC1C;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;0BAE0B;;AAE1B;;;EAGE,uDAAuD;AACzD;;AAEA,gBAAgB;AAChB;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,eAAe;AACf;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;0BAE0B;;AAE1B;EACE,wCAAwC;EACxC,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,iBAAiB;EACjB,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,iBAAiB;EACjB,iDAAiD;AACnD;;AAEA;;0BAE0B;;AAE1B;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;;0BAE0B;;AAE1B;EACE,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;0BAE0B;;AAE1B;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;0BAE0B;;AAE1B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;0BAE0B;;AAE1B;EACE,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;0BAE0B;;AAE1B;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;;0BAE0B;;AAE1B;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;EACvC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc,EAAE,wCAAwC;AAC1D;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;AACA;oDACoD,yBAAyB,EAAE;;AAE/E;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,sCAAsC;AACxC;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;EACd,iCAAiC;AACnC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,2BAA2B;EAC3B,iBAAiB;EACjB,6BAA6B;EAC7B,wBAAwB;EACxB,mBAAmB;EACnB,4BAA4B;EAC5B,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,cAAc;AAChB;AACA,+CAA+C,cAAc,EAAE;;AAE/D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;EACd,mDAAmD;AACrD;AACA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,iCAAiC;AACnC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,aAAa;AACf;AACA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;;uDAEuD;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;AAC5C;AACA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;AACA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,2BAA2B;EAC3B,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,oDAAoD;EACpD,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,0DAA0D;AAC5D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;;EAEE,uCAAuC;EACvC,2CAA2C;AAC7C;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,6CAA6C;EAC7C,UAAU;EACV,oBAAoB;EACpB,0DAA0D;AAC5D;AACA;EACE,WAAW,6CAA6C,EAAE;EAC1D,MAAM,iFAAiF,EAAE;AAC3F;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,aAAa;AACb,2CAA2C;AAC3C;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,6CAA6C;EAC7C,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kDAAkD;EAClD,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,yBAAyB;EACzB,mDAAmD;EACnD,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,gDAAgD;EAChD,sBAAsB;EACtB,sDAAsD;AACxD;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,8CAA8C;AAChD;;AAEA,cAAc;AACd;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,uCAAuC;EACvC,kCAAkC;AACpC;AACA,qBAAqB,mBAAmB,EAAE;AAC1C;EACE,mBAAmB;EACnB,oCAAoC;AACtC;AACA,mBAAmB,YAAY,EAAE,WAAW,EAAE;;AAE9C;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;AAC3B;AACA,qBAAqB,yBAAyB,EAAE;AAChD,sBAAsB,iCAAiC,EAAE;AACzD;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;AACA,4BAA4B,yBAAyB,EAAE;;AAEvD;EACE,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,aAAa;AACf;AACA,sCAAsC,kCAAkC,EAAE;;AAE1E;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;AACA,kBAAkB,YAAY,EAAE;AAChC,oBAAoB,gBAAgB,EAAE,cAAc,EAAE;AACtD,oCAAoC,cAAc,EAAE;AACpD;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA,mCAAmC,cAAc,EAAE;AACnD;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA,sCAAsC,gCAAgC,EAAE;;AAExE;EACE,iCAAiC;EACjC,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,oCAAoC;AACtC;AACA,mBAAmB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACtE,oCAAoC,gCAAgC,EAAE;AACtE,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACtE,oCAAoC,WAAW,EAAE;;AAEjD,2BAA2B;AAC3B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,mBAAmB,qCAAqC,EAAE;AAC5D;AACA;EACE,mBAAmB,qCAAqC,EAAE;AAC5D;AACA;EACE,mBAAmB,0BAA0B,EAAE;AACjD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,iDAAiD;EACjD,uDAAuD;EACvD,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;AACA,kBAAkB,mBAAmB,EAAE;;AAEvC;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;oCAEoC;AACpC;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,aAAa;EACb,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA,mCAAmC,WAAW,EAAE;;AAEhD;8CAC8C;AAC9C;oEACoE;AACpE,kBAAkB,sBAAsB,EAAE,2BAA2B,EAAE,2BAA2B,EAAE,gCAAgC,EAAE;AACtI,kBAAkB,sBAAsB,EAAE,2BAA2B,EAAE,2BAA2B,EAAE,gCAAgC,EAAE;AACtI,kBAAkB,sBAAsB,EAAE,2BAA2B,EAAE,2BAA2B,EAAE,gCAAgC,EAAE;AACtI,kBAAkB,sBAAsB,EAAE,2BAA2B,EAAE,2BAA2B,EAAE,gCAAgC,EAAE;AACtI,kBAAkB,sBAAsB,EAAE,2BAA2B,EAAE,2BAA2B,EAAE,gCAAgC,EAAE;AACtI,kBAAkB,sBAAsB,EAAE,2BAA2B,EAAE,2BAA2B,EAAE,gCAAgC,EAAE;;AAEtI,kBAAkB,mBAAmB,EAAE;AACvC;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA,wCAAwC,gCAAgC,EAAE;;AAE1E;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA,wCAAwC,WAAW,EAAE;AACrD,sCAAsC,cAAc,EAAE;AACtD,sDAAsD,cAAc,EAAE;;AAEtE;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;EACf,cAAc;EACd,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,uCAAuC;AACzC;AACA,yBAAyB,cAAc,EAAE,gBAAgB,EAAE;AAC3D,yCAAyC,WAAW,EAAE;AACtD,yCAAyC,cAAc,EAAE;AACzD,yDAAyD,cAAc,EAAE;;AAEzE;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;AACA,4BAA4B,mBAAmB,EAAE;AACjD,0BAA0B,mBAAmB,EAAE;;AAE/C,6BAA6B;AAC7B;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA,2BAA2B,WAAW,EAAE;AACxC,oBAAoB,eAAe,EAAE,yBAAyB,EAAE;;AAEhE;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB,EAAE,SAAS;EAC/B,eAAe;EACf,gBAAgB;EAChB,cAAc,iBAAiB,oBAAoB;EACnD,mBAAmB,YAAY,eAAe;EAC9C,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA,2BAA2B;AAC3B;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;AACA,uBAAuB,mBAAmB,EAAE;AAC5C;EACE,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,6BAA6B;AAC7B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;AACrB;AACA,wBAAwB,mBAAmB,EAAE;;AAE7C;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;AACA,yBAAyB,gBAAgB,EAAE;;AAE3C;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,WAAW;EACX,oCAAoC;AACtC;AACA;;2EAE2E;AAC3E;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;AACA,sBAAsB,gCAAgC,EAAE;;AAExD;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;AACA,2BAA2B,kCAAkC,EAAE;;AAE/D;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA,sBAAsB,kBAAkB,EAAE,UAAU,EAAE,YAAY,EAAE;AACpE,sBAAsB,gBAAgB,EAAE,kBAAkB,EAAE;AAC5D,qBAAqB,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE,eAAe,EAAE;AACzF,uBAAuB,cAAc,EAAE,gBAAgB,EAAE;AACzD,gDAAgD,gCAAgC,EAAE;;AAElF;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA,gDAAgD,kCAAkC,EAAE;;AAEpF;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;AACA,2CAA2C,gCAAgC,EAAE;;AAE7E,cAAc,iBAAiB,EAAE,kBAAkB,EAAE;AACrD,kBAAkB,YAAY,EAAE,WAAW,EAAE;;AAE7C,qBAAqB;AACrB;EACE,wBAAwB,iBAAiB,EAAE;AAC7C;;AAEA,iCAAiC;AACjC;EACE;IACE,aAAa;EACf;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,aAAa;EACf;;EAEA;;;;IAIE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,sCAAsC;EACxC;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;AACA,iEAAiE;AACjE;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,8DAA8D;AAC9D;EACE;IACE,wBAAwB;EAC1B;;EAEA,yCAAyC;EACzC;IACE,aAAa;EACf;;EAEA;;;;IAIE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,sBAAsB;IACtB,0CAA0C;IAC1C,qCAAqC;EACvC;;EAEA,2BAA2B;EAC3B;IACE,2CAA2C;IAC3C,0CAA0C;EAC5C;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;EACjB;;EAEA,oCAAoC;EACpC;IACE,mBAAmB;EACrB;;EAEA,6CAA6C;EAC7C;IACE,gBAAgB;EAClB;AACF;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,SAAS;EACT,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mDAAmD;AACrD;AACA,2BAA2B,6BAA6B,EAAE;;AAE1D;EACE,4BAA4B;AAC9B;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,4CAA4C;EAC5C,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,4DAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,4BAA4B;EAC5B,cAAc;AAChB;AACA,2BAA2B,kCAAkC,EAAE,gCAAgC,EAAE;;AAEjG;EACE,uCAAuC;EACvC,WAAW;AACb;;AAEA,gBAAgB,SAAO,EAAE,iBAAiB,EAAE;;AAE5C;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;AAChB;AACA,4BAA4B,iCAAiC,EAAE,6BAA6B,EAAE;;AAE9F;EACE,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA,6BAA6B,kCAAkC,EAAE,6BAA6B,EAAE;;AAEhG;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,cAAc;EACd,kCAAkC;AACpC;AACA,4BAA4B,oCAAoC,EAAE;;AAElE;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,+BAA+B;AACjC;AACA,uBAAuB,qBAAqB,EAAE;AAC9C;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,kCAAkC;EAClC,0CAA0C;AAC5C;AACA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4CAA4C;EAC5C,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,4DAA4D;AAC9D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,mDAAmD;AACrD;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,WAAW;AACb;AACA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,uGAAuG;AACzG;AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,8BAA8B;AAChC;AACA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kCAAkC;EAClC,mBAAmB;AACrB;AACA,kCAAkC,4DAA4D,EAAE;;AAEhG;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,yCAAyC;AAC3C;AACA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;AACA,oBAAoB,eAAe,EAAE,gBAAgB,EAAE;AACvD,oBAAoB,SAAS,EAAE,kBAAkB,EAAE;AACnD,mBAAmB,eAAe,EAAE,gBAAgB,EAAE;;AAEtD;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mDAAmD;AACrD;AACA,gBAAgB,mBAAmB,EAAE;AACrC,sBAAsB,gBAAgB,EAAE;AACxC,2BAA2B,0CAA0C,EAAE,mBAAmB,EAAE;AAC5F;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA,iCAAiC,WAAW,EAAE,UAAU,EAAE;AAC1D;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,+BAA+B;AACjC;AACA,gCAAgC,2BAA2B,EAAE;;AAE7D;;;oEAGoE;AACpE;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,uDAAuD;EACvD,iCAAiC;EACjC,iCAAiC;EACjC,6DAA6D;EAC7D,iCAAiC;EACjC,iCAAiC;EACjC,uEAAuE;EACvE,kCAAkC;EAClC,kCAAkC;EAClC,4CAA4C;EAC5C,yDAAyD;EACzD,oCAAoC;EACpC,gEAAgE;AAClE","sourcesContent":["@font-face {\n  font-family: \"Arimo-Regular\";\n  src: url(\"fonts/Figtree-Regular.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n/* Base Styles */\nbody,\n.App {\n  font-family: \"Arimo-Regular\", sans-serif;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.App {\n  text-align: center;\n}\n\n/* ========================\n   THEME STYLES\n======================== */\n\n/* Light Theme */\n.light-theme {\n  background-color: #eaecf0;\n  color: #202020;\n  font-family: \"Arimo-Regular\", sans-serif;\n}\n\n/* Dark Theme */\n.dark-theme {\n  background-color: #202020;\n  color: #f0f0f0;\n  font-family: \"Arimo-Regular\", sans-serif;\n}\n\n/* Utility text override */\n.light-theme .text-muted {\n  color: #475569 !important;\n}\n\n.dark-theme .text-muted {\n  color: #ccc !important;\n}\n\n.dark-ckeditor .ck.ck-editor__editable:not(.ck-editor__nested-editable) {\n  background-color: #1e1e1e;\n  color: #fff;\n}\n\n/* ========================\n   CARD STYLING\n======================== */\n\n.card,\n.dataset-card,\n.stat-card {\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n/* Light Cards */\n.light-theme .card,\n.light-theme .dataset-card,\n.light-theme .stat-card {\n  background-color: #ffffff;\n  color: #202020;\n}\n\n/* Dark Cards */\n.dark-theme .card,\n.dark-theme .dataset-card,\n.dark-theme .stat-card {\n  background-color: #2c2c2c;\n  color: #f0f0f0;\n}\n\n/* ========================\n   NAV TABS\n======================== */\n\n.custom-tab {\n  background-color: transparent !important;\n  border-radius: 30px 15px 0 0;\n  padding: 10px 20px;\n  font-weight: 500;\n  color: #5f5d5d !important;\n  transition: all 0.2s ease-in-out;\n}\n\n.custom-tab:hover {\n  background-color: #c2c7cc;\n  color: #000;\n}\n\n.active-tab {\n  background-color: #233b7b !important;\n  color: #fff !important;\n  font-weight: bold;\n  box-shadow: inset 4px 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.enq-tag-pill {\n  text-transform: uppercase !important;\n}\n\n.dark-theme .custom-tab {\n  background-color: #3a3a3a;\n  color: #ccc;\n}\n\n.dark-theme .custom-tab:hover {\n  background-color: #4a4a4a;\n  color: white;\n}\n\n.custom-tab.active {\n  background-color: #233b7b !important;\n  color: #fff !important;\n  font-weight: bold;\n  box-shadow: inset 4px 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n/* ========================\n   DATASET CARDS\n======================== */\n\n.dataset-card {\n  width: 100%;\n  min-height: 200px;\n  border-radius: 12px;\n  padding: 10px;\n  position: relative;\n}\n\n.dataset-card:hover {\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.bottom-image {\n  position: absolute;\n  bottom: 16px;\n  right: 16px;\n}\n\n/* ========================\n   STAT CARD\n======================== */\n\n.stat-card {\n  border-radius: 10px;\n  box-shadow: 8px 8px 16px #b0b4b9, -8px -8px 16px #ffffff;\n}\n\n.dark-theme .stat-card {\n  box-shadow: none;\n  border: 1px solid #444;\n}\n\n/* ========================\n   ACTIVITY\n======================== */\n\n.activity-entry {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.activity-line {\n  width: 4px;\n  height: 36px;\n  border-radius: 4px;\n  margin-top: 2px;\n}\n\n.activity-line-orange {\n  background-color: orange;\n}\n\n.activity-line-blue {\n  background-color: #233b7b;\n}\n\n/* ========================\n   CALENDAR ICON\n======================== */\n\n.calendar-icon-circle {\n  background-color: #233b7b;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.calendar-icon {\n  color: #f2f0ff;\n  font-size: 16px;\n}\n\n/* ========================\n   Theme-Based Table Support\n======================== */\n\n.table {\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.dark-theme .table {\n  background-color: #2c2c2c;\n  color: #f0f0f0;\n}\n\n.dark-theme .table thead {\n  background-color: #3a3a3a;\n  color: #ddd;\n}\n\n/* ========================\n   Miscellaneous\n======================== */\n\n.text-orange {\n  color: #f06700;\n}\n\n.btn-color {\n  background-color: #233b7b !important;\n}\n\n.dark-field {\n  background-color: #2c2c2c !important;\n  border-color: #ccc !important;\n}\n\n.dark-placeholder::placeholder {\n  color: #ccc !important;\n  opacity: 1;\n}\n\n/* ========================\n   Log In\n======================== */\n\n.login-container {\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: linear-gradient(135deg, #1e3c72, #2a5298);\n}\n\n.login-card {\n  display: flex;\n  background-color: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);\n  max-width: 700px;\n  width: 100%;\n}\n\n.login-left {\n  flex: 1;\n  background-color: #e6e7ea;\n  padding: 40px 30px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.login-left h4 {\n  margin-bottom: 20px;\n  font-size: 25px;\n  color: #111827; /* the card stays light in both themes */\n}\n\n.login-input {\n  margin-bottom: 20px;\n  padding: 12px;\n  border: none;\n  border-radius: 5px;\n  width: 100%;\n  font-size: 16px;\n  color: #111827;\n  background-color: #ffffff;\n}\n.login-card .login-input::placeholder,\n.dark-theme .login-card .login-input::placeholder { color: #4b5563 !important; }\n\n.login-button {\n  padding: 12px;\n  border: none;\n  border-radius: 5px;\n  background-color: #052b81;\n  color: white;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.login-button:hover {\n  background-color: #003c94;\n}\n\n.login-right {\n  flex: 1;\n  background-color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.login-right img {\n  max-width: 100%;\n  height: auto;\n  padding: 5px;\n}\n\n.activity-line {\n  width: 5px;\n  height: 40px;\n  border-radius: 5px;\n  margin-right: 8px;\n}\n\n.activity-line-blue {\n  background-color: #007bff;\n}\n\n.activity-line-green {\n  background-color: #28a745;\n}\n\n.activity-line-orange {\n  background-color: #e88316;\n}\n\n.activity-line-gray {\n  background-color: #ccc;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.icon-hover-animate:hover {\n  animation: bounceScale 0.6s ease-in-out;\n}\n\n@keyframes bounceScale {\n  0% {\n    transform: scale(1);\n  }\n  30% {\n    transform: scale(1.3);\n  }\n  60% {\n    transform: scale(0.95);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.icon-animate {\n  animation: bounceScale 0.6s ease-in-out;\n}\n\n.wave-emoji {\n  display: inline-block;\n  animation: wave 2s infinite;\n  transform-origin: 70% 70%;\n}\n\n@keyframes wave {\n  0% {\n    transform: rotate(0deg);\n  }\n  10% {\n    transform: rotate(14deg);\n  }\n  20% {\n    transform: rotate(-8deg);\n  }\n  30% {\n    transform: rotate(14deg);\n  }\n  40% {\n    transform: rotate(-4deg);\n  }\n  50% {\n    transform: rotate(10deg);\n  }\n  60% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n\n@media (max-width: 576px) {\n  .calendar-icon-circle {\n    width: 35px;\n    height: 35px;\n  }\n\n  .calendar-icon {\n    font-size: 1rem;\n  }\n\n  .badge {\n    font-size: 12px !important;\n    padding: 6px 10px !important;\n  }\n\n  h3,\n  h5 {\n    font-size: 1.25rem;\n  }\n\n  .fw-bold {\n    font-weight: 600 !important;\n  }\n}\n\n::-webkit-scrollbar {\n  height: 6px;\n}\n::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.3);\n  border-radius: 3px;\n}\n\n.table-responsive-sm {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 768px) {\n  .small-table-text {\n    font-size: 12px;\n  }\n\n  .small-table-text th,\n  .small-table-text td {\n    padding: 6px 8px;\n    font-size: 12px;\n  }\n}\n\n.badge-circle {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  background-color: red;\n  color: white;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: bold;\n  z-index: 10;\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.4);\n}\n\n/* ===== Enquiry Professional UI ===== */\n.enq-page-header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 10px;\n  margin-bottom: 14px;\n}\n\n.enq-title {\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: 0.2px;\n  margin-left: 10px;\n}\n\n.enq-subtitle {\n  font-size: 16px;\n  margin-top: 3px;\n  margin-left: 10px;\n}\n\n.enq-header-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.enq-pill-btn {\n  border-radius: 999px !important;\n  padding: 8px 14px !important;\n  font-weight: 600 !important;\n}\n\n.enq-stat-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: 0;\n  border-radius: 999px;\n  padding: 8px 16px;\n  font-weight: 600;\n  background: rgba(26, 52, 131, 0.08);\n  color: #1a3483;\n  transition: background 0.15s ease;\n}\n.enq-stat-chip:hover {\n  background: rgba(26, 52, 131, 0.14);\n}\n.enq-stat-chip strong {\n  background: #1a3483;\n  color: #fff;\n  border-radius: 999px;\n  padding: 2px 10px;\n  font-weight: 800;\n  font-size: 13px;\n}\n.dark-theme .enq-stat-chip {\n  background: rgba(255, 255, 255, 0.08);\n  color: #e5e7eb;\n}\n.dark-theme .enq-stat-chip:hover {\n  background: rgba(255, 255, 255, 0.14);\n}\n\n.enq-template-toggle {\n  border-radius: 999px !important;\n  padding: 8px 14px !important;\n  font-weight: 600 !important;\n  border: 1px solid;\n  background-color: transparent;\n  display: flex !important;\n  align-items: center;\n  flex-wrap: nowrap !important;\n  gap: 10px;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.enq-template-toggle-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.enq-template-toggle-chips {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  flex: 1 1 auto;\n  overflow: hidden;\n}\n\n.enq-template-toggle-placeholder {\n  font-size: 12px;\n  font-weight: 500;\n  opacity: 1;\n  color: #4b5563;\n}\n.dark-theme .enq-template-toggle-placeholder { color: #b6bcc6; }\n\n.enq-template-chip {\n  display: inline-flex;\n  align-items: center;\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 3px 9px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n}\n.enq-template-chip.email {\n  background: rgba(26, 52, 131, 0.12);\n  color: #1a3483;\n}\n.enq-template-chip.whatsapp {\n  background: rgba(37, 211, 102, 0.16);\n  color: #128c4a;\n}\n.dark-theme .enq-template-chip.email {\n  background: rgba(147, 197, 253, 0.18);\n  color: #93c5fd;\n}\n.dark-theme .enq-template-chip.whatsapp {\n  background: rgba(74, 222, 128, 0.18);\n  color: #4ade80;\n}\n\n.enq-template-tabs {\n  display: flex;\n  gap: 6px;\n}\n\n.enq-template-tab {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  border-radius: 999px;\n  padding: 9px 10px;\n  font-size: 13px;\n  font-weight: 700;\n  background: rgba(0, 0, 0, 0.05);\n  color: #4b5563;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n.bg-dark .enq-template-tab {\n  background: rgba(255, 255, 255, 0.08);\n  color: rgba(255, 255, 255, 0.72);\n}\n\n.enq-template-tab-email.active {\n  background: #1a3483;\n  color: #fff;\n}\n.enq-template-tab-whatsapp.active {\n  background: #25d366;\n  color: #fff;\n}\n\n.enq-template-list {\n  max-height: 260px;\n  overflow-y: auto;\n}\n\n.enq-template-list-modal {\n  max-height: 340px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.enq-template-row {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  text-align: left;\n  border: 0;\n  border-radius: 10px;\n  padding: 10px 12px;\n  font-size: 14px;\n  font-weight: 600;\n  background: transparent;\n  color: inherit;\n  transition: background 0.15s ease;\n}\n.enq-template-row:hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n.bg-dark .enq-template-row:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n.enq-template-row.active {\n  background: rgba(26, 52, 131, 0.1);\n  color: #1a3483;\n}\n.bg-dark .enq-template-row.active {\n  background: rgba(147, 197, 253, 0.15);\n  color: #93c5fd;\n}\n\n.enq-template-empty {\n  padding: 8px 16px;\n  font-size: 13px;\n  color: #475569;\n}\n\n.enq-card {\n  border-radius: 14px !important;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n}\n\n.enq-actions-row {\n  display: flex;\n  gap: 12px;\n  margin-top: 14px;\n  padding-top: 14px;\n  border-top: 1px solid rgba(0, 0, 0, 0.07);\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n.dark-theme .enq-actions-row {\n  border-top-color: rgba(255, 255, 255, 0.1);\n}\n\n.enq-toolbar-divider {\n  width: 1px;\n  height: 22px;\n  background: rgba(0, 0, 0, 0.12);\n  margin: 0 2px;\n}\n.dark-theme .enq-toolbar-divider {\n  background: rgba(255, 255, 255, 0.14);\n}\n\n.enq-left-actions,\n.enq-right-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.enq-action-btn {\n  border-radius: 12px !important;\n  padding: 8px 12px !important;\n  font-weight: 600 !important;\n}\n\n.enq-filters .btn {\n  border-radius: 999px !important;\n  font-weight: 700;\n}\n\n.enq-filter-btn.active {\n  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.08);\n  transform: translateY(-1px);\n}\n\n.enq-badge {\n  border-radius: 999px !important;\n  font-weight: 800 !important;\n}\n\n/* Calm \"not linked yet / can't load\" state for the WhatsApp Conversation\n   panel — deliberately not styled as a red/danger error, since this is a\n   normal, expected wait rather than something wrong. */\n.enq-wa-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 8px;\n  padding: 28px 16px;\n  border-radius: 14px;\n  background: rgba(13, 110, 253, 0.05);\n  border: 1px dashed rgba(13, 110, 253, 0.2);\n}\n.enq-wa-empty.dark {\n  background: rgba(255, 255, 255, 0.04);\n  border-color: rgba(255, 255, 255, 0.15);\n}\n.enq-wa-empty-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  background: rgba(13, 110, 253, 0.12);\n  color: #0d6efd;\n}\n.enq-wa-empty.dark .enq-wa-empty-icon {\n  background: rgba(255, 255, 255, 0.1);\n  color: #8ab4ff;\n}\n.enq-wa-empty-text {\n  font-size: 13.5px;\n  color: #5b6472;\n  max-width: 300px;\n  line-height: 1.5;\n  text-wrap: balance;\n}\n.enq-wa-empty.dark .enq-wa-empty-text {\n  color: rgba(255, 255, 255, 0.72);\n}\n\n.enq-wa-template-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.enq-wa-template-icon {\n  position: absolute;\n  left: 14px;\n  font-size: 13px;\n  color: #475569;\n  pointer-events: none;\n}\n.dark-theme .enq-wa-template-icon {\n  color: rgba(255, 255, 255, 0.72);\n}\n\n.enq-wa-template-select {\n  border-radius: 999px !important;\n  padding: 8px 14px 8px 36px !important;\n  font-size: 13px;\n  font-weight: 600;\n  border-color: rgba(0, 0, 0, 0.12) !important;\n}\n.dark-theme .enq-wa-template-select {\n  border-color: rgba(255, 255, 255, 0.16) !important;\n}\n\n.enq-wa-composer {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  border-radius: 18px;\n  background: #ffffff;\n  padding: 6px 6px 6px 10px;\n}\n.enq-wa-composer.dark {\n  background: #232427;\n  border-color: rgba(255, 255, 255, 0.14);\n}\n.enq-wa-composer:focus-within {\n  border-color: #25d366;\n  box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.15);\n}\n\n.enq-wa-attach-btn {\n  border: 0;\n  background: transparent;\n  color: #475569;\n  width: 32px;\n  height: 32px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-bottom: 3px;\n  transition: background 0.15s ease;\n}\n.enq-wa-composer.dark .enq-wa-attach-btn {\n  color: rgba(255, 255, 255, 0.72);\n}\n.enq-wa-attach-btn:hover {\n  background: rgba(0, 0, 0, 0.06);\n}\n.enq-wa-composer.dark .enq-wa-attach-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n.enq-wa-attach-btn:disabled {\n  opacity: 1;\n  cursor: not-allowed;\n}\n\n.enq-wa-textarea.form-control {\n  border: 0 !important;\n  background: transparent !important;\n  box-shadow: none !important;\n  padding: 6px 4px !important;\n  resize: none;\n}\n.enq-wa-textarea.form-control:focus {\n  box-shadow: none !important;\n}\n\n.enq-wa-send-btn {\n  border: 0;\n  background: #25d366;\n  color: #fff;\n  width: 36px;\n  height: 36px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: background 0.15s ease, transform 0.1s ease;\n}\n.enq-wa-send-btn:hover:not(:disabled) {\n  background: #1fb857;\n  transform: scale(1.05);\n}\n.enq-wa-send-btn:disabled {\n  background: #475569;\n  cursor: not-allowed;\n}\n\n.enq-table {\n  font-size: 15px;\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.enq-thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #f8f9fa;\n  border-bottom: 1px solid rgba(0,0,0,0.08) !important;\n  font-weight: 800;\n}\n\n.table-dark .enq-thead th {\n  background: #1f1f1f !important;\n  border-bottom: 1px solid rgba(255,255,255,0.12) !important;\n}\n\n.enq-checkbox .form-check-input {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #6b7280;\n  cursor: pointer;\n  box-shadow: none;\n}\n.enq-checkbox .form-check-input:checked {\n  background-color: #1a3483;\n  border-color: #1a3483;\n}\n.enq-checkbox .form-check-input:focus {\n  border-color: #1a3483;\n  box-shadow: 0 0 0 3px rgba(26, 52, 131, 0.25);\n}\n.table-dark .enq-checkbox .form-check-input,\n.dark-theme .enq-checkbox .form-check-input {\n  border-color: rgba(255, 255, 255, 0.65);\n  background-color: rgba(255, 255, 255, 0.08);\n}\n.table-dark .enq-checkbox .form-check-input:checked,\n.dark-theme .enq-checkbox .form-check-input:checked {\n  background-color: #3987e5;\n  border-color: #3987e5;\n}\n\n.enq-email {\n  font-weight: 600;\n}\n\n.enq-chip {\n  color: #fff;\n  font-weight: 800;\n  font-size: 12px;\n  padding: 6px 10px;\n  border-radius: 999px;\n  display: inline-block;\n  text-transform: capitalize;\n}\n\n.enq-action-icons {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.enq-icon-btn {\n  border: 1px solid rgba(0,0,0,0.08);\n  background: rgba(0,0,0,0.02);\n  border-radius: 10px;\n  width: 34px;\n  height: 34px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all .15s ease;\n}\n\n.table-dark .enq-icon-btn {\n  border: 1px solid rgba(255,255,255,0.12);\n  background: rgba(255,255,255,0.04);\n  color: #fff;\n}\n\n.enq-icon-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 10px 16px rgba(0,0,0,0.10);\n}\n\n.enq-icon-btn.danger {\n  color: #dc3545;\n}\n.table-dark .enq-icon-btn.danger {\n  color: #f1a3ab;\n}\n\n.enq-icon-btn.danger:hover {\n  border-color: rgba(220, 53, 69, 0.35);\n  background: rgba(220, 53, 69, 0.08);\n}\n\n/* New WhatsApp message badge, pinned above the View (eye) icon */\n.enq-icon-btn-wrap {\n  position: relative;\n  display: inline-flex;\n}\n.enq-new-message-badge {\n  position: absolute;\n  top: -9px;\n  right: -8px;\n  background: #25d366;\n  color: #073b1e;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.3px;\n  line-height: 1;\n  padding: 3px 5px;\n  border-radius: 999px;\n  white-space: nowrap;\n  box-shadow: 0 2px 8px rgba(37, 211, 102, 0.5);\n  z-index: 2;\n  pointer-events: none;\n  animation: enq-new-message-pulse 1.6s ease-in-out infinite;\n}\n@keyframes enq-new-message-pulse {\n  0%, 100% { box-shadow: 0 2px 8px rgba(37, 211, 102, 0.5); }\n  50% { box-shadow: 0 2px 8px rgba(37, 211, 102, 0.9), 0 0 0 3px rgba(37, 211, 102, 0.18); }\n}\n\n.enq-empty-title {\n  font-size: 16px;\n  font-weight: 900;\n  margin-bottom: 6px;\n}\n\n/* Top Menu */\n/* ===== TMIS Topbar (Professional) ===== */\n.tmis-topbar {\n  background: #ffffff;\n  border-bottom: 1px solid rgba(16, 24, 40, 0.08);\n  box-shadow: 0 6px 20px rgba(16, 24, 40, 0.06);\n  border-radius: 14px;\n  margin: 14px 0;\n}\n\n.tmis-topbar--dark {\n  background: #292a32;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);\n}\n\n.tmis-logo {\n  height: 40px;\n  width: auto;\n  object-fit: contain;\n}\n\n.tmis-brand-title {\n  font-weight: 800;\n  letter-spacing: 0.2px;\n  line-height: 1.05;\n}\n\n.tmis-brand-sub {\n  font-size: 12px;\n  margin-top: 2px;\n}\n\n.tmis-badge-soft {\n  font-size: 12px;\n  padding: 6px 8px;\n  border-radius: 999px;\n}\n\n/* Icon Buttons */\n.tmis-icon-btn {\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(16, 24, 40, 0.04) !important;\n  color: #233b7b !important;\n  border: 1px solid rgba(16, 24, 40, 0.06) !important;\n  transition: all 0.18s ease;\n}\n\n.tmis-icon-btn:hover {\n  transform: translateY(-1px);\n  background: rgba(35, 59, 123, 0.10) !important;\n}\n\n.tmis-icon-btn--dark {\n  background: rgba(255, 255, 255, 0.06) !important;\n  color: #fff !important;\n  border: 1px solid rgba(255, 255, 255, 0.10) !important;\n}\n\n.tmis-icon-btn--danger {\n  background: rgba(220, 53, 69, 0.10) !important;\n  color: #dc3545 !important;\n  border: 1px solid rgba(220, 53, 69, 0.20) !important;\n}\n\n.tmis-icon-btn--danger:hover {\n  background: rgba(220, 53, 69, 0.18) !important;\n}\n\n/* Offcanvas */\n.tmis-offcanvas-dark {\n  background: #121723 !important;\n}\n\n.tmis-drawer-link {\n  border-radius: 12px;\n  padding: 10px 12px !important;\n  font-weight: 700;\n  color: #1f2a44 !important;\n  background: rgba(16, 24, 40, 0.04);\n}\n\n.tmis-drawer-link:hover {\n  background: rgba(35, 59, 123, 0.10);\n}\n\n.tmis-drawer-link--dark {\n  color: #fff !important;\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.tmis-drawer-link--dark:hover {\n  background: rgba(255, 255, 255, 0.10);\n}\n\n/* ===== Shell ===== */\n.tmis-shell {\n  min-height: 100vh;\n  padding: 18px;\n  background: #f5f7fb;\n}\n.tmis-shell.dark {\n  background: #0f1220;\n}\n\n/* ===== Topbar ===== */\n.tmis-topbar {\n  border-radius: 14px;\n  padding: 10px 6px;\n  box-shadow: 0 8px 18px rgba(0,0,0,0.06);\n  border: 1px solid rgba(0,0,0,0.06);\n}\n.tmis-topbar.light { background: #ffffff; }\n.tmis-topbar.dark {\n  background: #14182a;\n  border-color: rgba(255,255,255,0.06);\n}\n.tmis-brand-logo { height: 34px; width: auto; }\n\n.tmis-navlink {\n  border-radius: 999px;\n  padding: 10px 14px !important;\n  font-weight: 600;\n  color: #1f2a37 !important;\n}\n.tmis-navlink.dark { color: #e5e7eb !important; }\n.tmis-navlink:hover { background: rgba(59,130,246,0.08); }\n.tmis-navlink.active {\n  background: rgba(59,130,246,0.14);\n  color: #0b5ed7 !important;\n}\n.tmis-navlink.active.dark { color: #93c5fd !important; }\n\n.tmis-nav-divider {\n  width: 1px;\n  height: 26px;\n  background: rgba(0,0,0,0.12);\n  margin: 0 6px;\n}\n.tmis-topbar.dark .tmis-nav-divider { background: rgba(255,255,255,0.14); }\n\n.tmis-pillbtn {\n  border-radius: 999px !important;\n  padding: 10px 14px !important;\n  font-weight: 700 !important;\n}\n.tmis-iconbtn {\n  width: 40px;\n  height: 40px;\n  border-radius: 999px !important;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* ===== Hero ===== */\n.tmis-hero {\n  border: 0;\n  border-radius: 14px;\n  overflow: hidden;\n}\n\n.tmis-hero.dark {\n  background: #2a2b2c;\n}\n.tmis-hero-body {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 18px 18px;\n}\n.tmis-hero-left { min-width: 0; }\n.tmis-hero-kicker { font-weight: 700; color: #222223; }\n.tmis-hero.dark .tmis-hero-kicker { color: #e5e7eb; }\n.tmis-hero-title {\n  font-size: 26px;\n  font-weight: 800;\n  line-height: 1.15;\n  margin-top: 5px;\n  color: #222223;\n}\n.tmis-hero.dark .tmis-hero-title { color: #ffffff; }\n.tmis-hero-subtitle {\n  margin-top: 10px;\n  color: #393939;\n  font-weight: 500;\n  font-size: 14px;\n}\n.tmis-hero.dark .tmis-hero-subtitle { color: rgba(255, 255, 255, 0.72); }\n\n.tmis-clock {\n  background: rgba(255,255,255,0.8);\n  border: 1px solid rgba(0,0,0,0.06);\n  border-radius: 14px;\n  padding: 10px 12px;\n  min-width: 160px;\n  text-align: right;\n}\n.tmis-clock.dark {\n  background: rgba(0,0,0,0.22);\n  border-color: rgba(255,255,255,0.08);\n}\n.tmis-clock-date { font-size: 12px; color: #475569; font-weight: 700; }\n.tmis-clock.dark .tmis-clock-date { color: rgba(255, 255, 255, 0.72); }\n.tmis-clock-time { font-size: 18px; font-weight: 900; color: #0f172a; }\n.tmis-clock.dark .tmis-clock-time { color: #fff; }\n\n/* ===== Stat Cards ===== */\n.tmis-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 14px;\n  align-items: stretch;\n}\n@media (max-width: 1199px) {\n  .tmis-stats-grid { grid-template-columns: repeat(3, 1fr); }\n}\n@media (max-width: 767px) {\n  .tmis-stats-grid { grid-template-columns: repeat(2, 1fr); }\n}\n@media (max-width: 480px) {\n  .tmis-stats-grid { grid-template-columns: 1fr; }\n}\n\n.tmis-stat {\n  position: relative;\n  width: 100%;\n  border: 0;\n  border-radius: 14px;\n  box-shadow: 0 10px 20px rgba(0,0,0,0.08);\n  background: #ffffff;\n  border-top: 4px solid var(--tmis-accent, #1a3483);\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\n  overflow: hidden;\n}\n.tmis-stat:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 14px 26px rgba(0,0,0,0.12);\n}\n.tmis-stat.dark { background: #2a2b2c; }\n\n.tmis-stat-body {\n  position: relative;\n  z-index: 1;\n  padding: 14px;\n}\n\n.tmis-stat-top {\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n  min-width: 0;\n}\n\n/* Big decorative icon, half-clipped off the card's right edge - identity\n   watermark rather than a functional element (pointer-events off, low\n   opacity, sits behind the text). */\n.tmis-stat-icon-bg {\n  position: absolute;\n  top: 40%;\n  right: -30px;\n  transform: translateY(-50%);\n  font-size: 100px;\n  line-height: 1;\n  color: var(--tmis-accent, #1a3483);\n  opacity: 0.14;\n  z-index: 0;\n  pointer-events: none;\n}\n.tmis-stat.dark .tmis-stat-icon-bg {\n  color: var(--tmis-accent-dark, #93c5fd);\n  opacity: 0.16;\n}\n\n.tmis-stat-title {\n  font-weight: 800;\n  font-size: 13px;\n  color: #111827;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  cursor: default;\n}\n.tmis-stat.dark .tmis-stat-title { color: #fff; }\n\n/* Per-card accent, assigned in a fixed order so each channel keeps a\n   consistent identity across the dashboard. */\n/* Shared identity palette (reused by Dashboard stat cards, Kanban columns,\n   and anywhere else that needs a fixed-order categorical accent). */\n.accent-blue    { --tmis-accent: #1a3483; --tmis-accent-tint: #e6ebf8; --tmis-accent-dark: #3987e5; --tmis-accent-dark-text: #9dc3f4; }\n.accent-violet  { --tmis-accent: #653b9e; --tmis-accent-tint: #efe7fa; --tmis-accent-dark: #7c3aed; --tmis-accent-dark-text: #c8b7f7; }\n.accent-teal    { --tmis-accent: #0a5d5c; --tmis-accent-tint: #e2f4f2; --tmis-accent-dark: #199e70; --tmis-accent-dark-text: #2ed99e; }\n.accent-green   { --tmis-accent: #0a5f34; --tmis-accent-tint: #e2f6ea; --tmis-accent-dark: #4ade80; --tmis-accent-dark-text: #5ee38f; }\n.accent-magenta { --tmis-accent: #9c1f55; --tmis-accent-tint: #fbe7ef; --tmis-accent-dark: #d55181; --tmis-accent-dark-text: #edb1c9; }\n.accent-slate   { --tmis-accent: #475569; --tmis-accent-tint: #eceff3; --tmis-accent-dark: #94a3b8; --tmis-accent-dark-text: #bbc8d2; }\n\n.tmis-stat-hero { margin-bottom: 10px; }\n.tmis-stat-hero-label {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #475569;\n}\n.tmis-stat.dark .tmis-stat-hero-label { color: rgba(255, 255, 255, 0.72); }\n\n.tmis-stat-hero-value {\n  font-size: 30px;\n  font-weight: 850;\n  line-height: 1.15;\n  color: #111827;\n}\n.tmis-stat.dark .tmis-stat-hero-value { color: #fff; }\n.tmis-stat-hero-value.tmis-hero-red { color: #b22222; }\n.tmis-stat.dark .tmis-stat-hero-value.tmis-hero-red { color: #fca5a5; }\n\n.tmis-stat-foot {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px 12px;\n  font-size: 12px;\n  color: #475569;\n  border-top: 1px solid rgba(0,0,0,0.06);\n  padding-top: 8px;\n}\n.tmis-stat.dark .tmis-stat-foot {\n  color: rgba(255, 255, 255, 0.72);\n  border-top-color: rgba(255,255,255,0.1);\n}\n.tmis-stat-foot strong { color: #111827; font-weight: 800; }\n.tmis-stat.dark .tmis-stat-foot strong { color: #fff; }\n.tmis-stat-foot strong.tmis-foot-green { color: #0d602d; }\n.tmis-stat.dark .tmis-stat-foot strong.tmis-foot-green { color: #4ade80; }\n\n.tmis-mini-pill {\n  border-radius: 999px;\n  padding: 6px 10px;\n  font-weight: 800;\n  border: 0;\n}\n.tmis-mini-pill.responded { background: #0d6e39; }\n.tmis-mini-pill.pending { background: #b02a37; }\n\n/* ===== Section Head ===== */\n.tmis-section-head {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 4px;\n}\n.tmis-section-title {\n  font-weight: 900;\n  font-size: 16px;\n  color: #0f172a;\n}\n.tmis-section-title.dark { color: #fff; }\n.tmis-section-sub { font-size: 13px; color: #544c47 !important; }\n\n.tmis-count-pill {\n  border-radius: 999px;\n  padding: 10px 14px;\n  font-weight: 900;\n  background: #ffedd5;\n  color: #c2410c;\n}\n\n.tmis-enq-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border-radius: 999px; /* pill */\n  font-size: 13px;\n  font-weight: 600;\n  color: #0f5132;                /* dark green text */\n  background: #e6f4ea;           /* soft green */\n  border: 1px solid #b7e1c1;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n}\n\n/* ===== Table Card ===== */\n.tmis-tablecard {\n  border: 0;\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 10px 20px rgba(0,0,0,0.08);\n}\n.tmis-tablecard.dark { background: #14182a; }\n.tmis-tablecard table thead th {\n  font-size: 14px;\n  letter-spacing: .04em;\n}\n.tmis-tablecard table  td {\n  font-size: 14px !important;\n}\n.tmis-ellipsis {\n  max-width: 260px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ===== Status Pills ===== */\n.tmis-pill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  padding: 6px 12px;\n  font-weight: 800;\n  font-size: 12px;\n  color: #fff;\n}\n\n/* ===== Activities Panel ===== */\n.tmis-activities {\n  width: 100%;\n  border: 0;\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 10px 20px rgba(0,0,0,0.08);\n  background: #ffffff;\n}\n.tmis-activities.dark { background: #2a2b2c; }\n\n.tmis-activities-head {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  background: #ffffff;\n  border-bottom: 1px solid rgba(0,0,0,0.06);\n  padding: 12px 14px;\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap: 10px;\n}\n.tmis-activities-head.dark {\n  background: #2e2e2e;\n  border-bottom-color: rgba(255,255,255,0.08);\n}\n.tmis-activities-title { font-weight: 900; }\n\n.tmis-activities-body {\n  padding: 12px 12px;\n  max-height: calc(100vh - 210px);\n  overflow: auto;\n}\n\n.tmis-compact-select {\n  border-radius: 10px;\n  font-weight: 800;\n}\n.tmis-compact-select.dark {\n  background: rgba(255,255,255,0.06);\n  color: #fff;\n  border-color: rgba(255,255,255,0.10);\n}\n/* The dropdown's option list is a separate native popup that doesn't\n   inherit the select's translucent background - style it explicitly with\n   an opaque dark background, or the (inherited) white text is invisible. */\n.tmis-compact-select.dark option {\n  background-color: #2a2b2c;\n  color: #fff;\n}\n\n.tmis-circle-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  background: #eef2ff;\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  color: #1d4ed8;\n}\n.tmis-activities.dark .tmis-circle-icon {\n  background: rgba(255,255,255,0.08);\n  color: #93c5fd;\n}\n\n.tmis-date-sep {\n  font-weight: 900;\n  font-size: 12px;\n  color: #475569;\n  margin: 8px 2px 10px;\n}\n.tmis-date-sep.dark { color: rgba(255, 255, 255, 0.72); }\n\n.tmis-activity-card {\n  position: relative;\n  border-radius: 14px;\n  padding: 12px 12px;\n  background: #f8fafc;\n  border-left: 6px solid #f59e0b;\n  display: flex;\n  align-items: stretch;\n  justify-content: space-between;\n  gap: 10px;\n  overflow: hidden;\n  margin-bottom: 10px;\n}\n.tmis-activity-card.dark { background: rgba(255,255,255,0.06); }\n\n.tmis-activity-decor {\n  position: absolute;\n  right: -18px;\n  bottom: -18px;\n  width: 110px;\n  opacity: 0.25;\n  pointer-events: none;\n}\n\n.tmis-activity-main { position: relative; z-index: 2; min-width: 0; }\n.tmis-activity-name { font-weight: 900; margin-bottom: 6px; }\n.tmis-activity-row { display:flex; align-items:center; font-size: 12px; margin-top: 2px; }\n.tmis-activity-muted { color: #475569; font-weight: 700; }\n.tmis-activity-card.dark .tmis-activity-muted { color: rgba(255, 255, 255, 0.72); }\n\n.tmis-activity-stamp {\n  position: relative;\n  z-index: 2;\n  min-width: 54px;\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  background: rgba(0,0,0,0.03);\n  border-radius: 12px;\n}\n.tmis-activity-card.dark .tmis-activity-stamp { background: rgba(255,255,255,0.06); }\n\n.tmis-checkmark {\n  font-weight: 900;\n  font-size: 26px;\n  color: rgba(31,41,55,0.20);\n}\n.tmis-activity-card.dark .tmis-checkmark { color: rgba(255, 255, 255, 0.72); }\n\n.tmis-empty { text-align:center; padding: 30px 10px; }\n.tmis-empty-img { width: 120px; opacity: .9; }\n\n/* Responsive tweak */\n@media (max-width: 991px) {\n  .tmis-activities-body { max-height: 520px; }\n}\n\n/* ---------- Tablet ---------- */\n@media (max-width: 991px) {\n  .hide-md {\n    display: none;\n  }\n}\n\n/* ---------- Mobile ---------- */\n@media (max-width: 767px) {\n  .enq-table thead {\n    display: none;\n  }\n\n  .enq-table,\n  .enq-table tbody,\n  .enq-table tr,\n  .enq-table td {\n    display: block;\n    width: 100%;\n  }\n\n  .enq-table tr {\n    background: #fff;\n    border-radius: 12px;\n    margin-bottom: 14px;\n    padding: 12px;\n    box-shadow: 0 6px 16px rgba(0,0,0,.08);\n  }\n\n  .enq-table td {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 6px 0;\n    border: none;\n    font-size: 14px;\n  }\n\n  .enq-table td::before {\n    content: attr(data-label);\n    font-weight: 600;\n    color: #666;\n  }\n\n  .hide-lg {\n    display: none;\n  }\n}\n/* ---------- Tablet: hide some columns to fit width ---------- */\n@media (max-width: 991px) {\n  .tmis-hide-md {\n    display: none !important;\n  }\n}\n\n/* ---------- Small tablet/large phone: hide more ---------- */\n@media (max-width: 767px) {\n  .tmis-hide-lg {\n    display: none !important;\n  }\n\n  /* Hide header, convert rows into cards */\n  .tmis-table-responsive thead {\n    display: none;\n  }\n\n  .tmis-table-responsive,\n  .tmis-table-responsive tbody,\n  .tmis-table-responsive tr,\n  .tmis-table-responsive td {\n    display: block;\n    width: 100%;\n  }\n\n  .tmis-table-responsive tr.tmis-row {\n    border-radius: 14px;\n    margin: 12px 0;\n    padding: 12px 12px 8px;\n    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);\n    border: 1px solid rgba(0, 0, 0, 0.06);\n  }\n\n  /* Dark mode card borders */\n  .table-dark tr.tmis-row {\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.25);\n  }\n\n  .tmis-table-responsive td {\n    display: flex;\n    justify-content: space-between;\n    gap: 14px;\n    padding: 8px 0;\n    border: 0 !important;\n    white-space: normal;\n  }\n\n  .tmis-table-responsive td::before {\n    content: attr(data-label);\n    font-weight: 700;\n    min-width: 92px;\n  }\n\n  /* Keep status pill aligned nicely */\n  .tmis-table-responsive td[data-label=\"Status\"] {\n    align-items: center;\n  }\n\n  /* Optional: make first two fields stronger */\n  .tmis-table-responsive td[data-label=\"Name\"] {\n    font-weight: 700;\n  }\n}\n\n/* ===== Data Center ===== */\n.dc-sidebar {\n  border-radius: 18px;\n  border: 0;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);\n  padding: 12px;\n}\n\n.dc-nav-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 12px;\n  border-radius: 14px;\n  border: 0;\n  background: transparent;\n  text-align: left;\n  font-weight: 700;\n  font-size: 14px;\n  color: #374151;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n.dark-theme .dc-nav-item { color: rgba(255,255,255,0.75); }\n\n.dc-nav-item:hover {\n  background: rgba(0,0,0,0.04);\n}\n.dark-theme .dc-nav-item:hover {\n  background: rgba(255,255,255,0.06);\n}\n\n.dc-nav-item.active {\n  background: var(--tmis-accent-tint, #eef2ff);\n  color: var(--tmis-accent, #1a3483);\n}\n.dark-theme .dc-nav-item.active {\n  background: rgba(255,255,255,0.09);\n  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));\n}\n\n.dc-nav-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 11px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 17px;\n  flex-shrink: 0;\n  background: rgba(0,0,0,0.05);\n  color: #475569;\n}\n.dark-theme .dc-nav-icon { background: rgba(255,255,255,0.08); color: rgba(255, 255, 255, 0.72); }\n\n.dc-nav-item.active .dc-nav-icon {\n  background: var(--tmis-accent, #1a3483);\n  color: #fff;\n}\n\n.dc-nav-label { flex: 1; line-height: 1.25; }\n\n.dc-nav-count {\n  min-width: 24px;\n  height: 22px;\n  padding: 0 7px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 800;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0,0,0,0.06);\n  color: #374151;\n}\n.dark-theme .dc-nav-count { background: rgba(255,255,255,0.1); color: rgba(255,255,255,0.75); }\n\n.dc-nav-item.active .dc-nav-count {\n  background: var(--tmis-accent, #1a3483);\n  color: #fff;\n}\n\n.dc-table-card {\n  border-radius: 18px !important;\n  border: 0 !important;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);\n}\n\n.dc-color-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 4px 10px 4px 6px;\n  border-radius: 999px;\n  background: rgba(0,0,0,0.04);\n  font-size: 12px;\n  font-weight: 700;\n  color: #374151;\n}\n.dark-theme .dc-color-chip { background: rgba(255,255,255,0.07); color: rgba(255,255,255,0.75); }\n\n.dc-color-dot {\n  width: 14px;\n  height: 14px;\n  border-radius: 999px;\n  flex-shrink: 0;\n  border: 1px solid rgba(0,0,0,0.12);\n}\n.dark-theme .dc-color-dot { border-color: rgba(255,255,255,0.25); }\n\n.dc-swatch-btn {\n  width: 24px;\n  height: 24px;\n  border-radius: 8px;\n  cursor: pointer;\n  border: 1px solid rgba(0,0,0,0.15);\n  transition: transform 0.1s ease;\n}\n.dc-swatch-btn:hover { transform: scale(1.1); }\n.dc-swatch-btn.selected {\n  outline: 2px solid var(--tmis-accent, #1a3483);\n  outline-offset: 2px;\n}\n\n/* ===== Total Counts sidebar ===== */\n.enq-count-stats {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.enq-count-stat {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border-radius: 16px;\n  padding: 14px;\n  background: #fff;\n  border: 1px solid rgba(0,0,0,0.06);\n  box-shadow: 0 8px 20px rgba(15,23,42,0.06);\n}\n.dark-theme .enq-count-stat {\n  background: #232427;\n  border-color: rgba(255,255,255,0.1);\n}\n\n.enq-count-stat-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  background: var(--tmis-accent-tint, #eef2ff);\n  color: var(--tmis-accent, #1a3483);\n}\n.dark-theme .enq-count-stat-icon {\n  background: rgba(255,255,255,0.08);\n  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));\n}\n\n.enq-count-stat-value {\n  font-size: 24px;\n  font-weight: 850;\n  line-height: 1.1;\n}\n\n.enq-count-stat-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #475569;\n  margin-top: 2px;\n}\n.dark-theme .enq-count-stat-label {\n  color: rgba(255, 255, 255, 0.72);\n}\n\n.enq-count-tabs {\n  display: flex;\n  gap: 6px;\n  padding: 4px;\n  border-radius: 999px;\n  background: rgba(0,0,0,0.05);\n  margin-bottom: 14px;\n}\n.dark-theme .enq-count-tabs {\n  background: rgba(255,255,255,0.06);\n}\n\n.enq-count-tab {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border: 0;\n  border-radius: 999px;\n  padding: 9px 12px;\n  font-weight: 700;\n  font-size: 14px;\n  background: transparent;\n  color: #4b5563;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n.dark-theme .enq-count-tab {\n  color: rgba(255, 255, 255, 0.72);\n}\n.enq-count-tab.active {\n  background: #1a3483;\n  color: #fff;\n  box-shadow: 0 6px 14px rgba(26,52,131,0.3);\n}\n\n.enq-count-tab-badge {\n  background: rgba(0,0,0,0.08);\n  border-radius: 999px;\n  padding: 1px 8px;\n  font-size: 12px;\n  font-weight: 800;\n}\n.enq-count-tab.active .enq-count-tab-badge {\n  background: rgba(255,255,255,0.25);\n  color: #fff;\n}\n.dark-theme .enq-count-tab-badge {\n  background: rgba(255,255,255,0.12);\n  color: #e5e7eb;\n}\n\n.enq-count-hint {\n  font-size: 12.5px;\n  color: #475569;\n  margin-bottom: 10px;\n}\n.dark-theme .enq-count-hint {\n  color: rgba(255, 255, 255, 0.72);\n}\n\n.enq-count-clear {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 0;\n  background: rgba(220,53,69,0.1);\n  color: #dc3545;\n  font-size: 12.5px;\n  font-weight: 700;\n  border-radius: 999px;\n  padding: 5px 12px;\n  margin-bottom: 12px;\n}\n.enq-count-clear:hover {\n  background: rgba(220,53,69,0.18);\n}\n\n.enq-count-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border-radius: 16px;\n  padding: 12px 14px;\n  background: #fff;\n  border: 1px solid rgba(0,0,0,0.06);\n  border-left: 4px solid transparent;\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease, border-color 0.15s ease;\n}\n.dark-theme .enq-count-item {\n  background: #232427;\n  border-color: rgba(255,255,255,0.08);\n  border-left-color: transparent;\n}\n.enq-count-item:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 10px 20px rgba(15,23,42,0.1);\n}\n.enq-count-item.selected {\n  background: rgba(26,52,131,0.05);\n  border-left-color: var(--item-color, #1a3483);\n}\n.dark-theme .enq-count-item.selected {\n  background: rgba(255,255,255,0.06);\n}\n\n.enq-count-item-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n}\n\n.enq-count-item-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.enq-count-item-name {\n  font-weight: 700;\n  font-size: 14px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.enq-count-item-type {\n  font-size: 12px;\n  color: #475569;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  font-weight: 700;\n}\n\n.enq-count-item-value {\n  text-align: right;\n  flex-shrink: 0;\n}\n\n.enq-count-item-number {\n  font-size: 20px;\n  font-weight: 850;\n  line-height: 1.1;\n}\n\n.enq-count-item-suffix {\n  font-size: 12px;\n  color: #475569;\n}\n\n.enq-count-item-check {\n  flex-shrink: 0;\n  color: var(--item-color, #1a3483);\n  font-size: 14px;\n}\n\n/* ===== Data Center: Privacy & Security ===== */\n.dc-privacy-eyebrow {\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: var(--tmis-accent, #0a5f34);\n  margin-bottom: 14px;\n}\n.dark-theme .dc-privacy-eyebrow { color: var(--tmis-accent-dark-text, var(--tmis-accent-dark)); }\n\n.dc-privacy-row {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 18px 20px;\n  border-radius: 16px;\n  background: rgba(18, 140, 74, 0.05);\n  border: 1px solid rgba(18, 140, 74, 0.18);\n}\n.dark-theme .dc-privacy-row {\n  background: rgba(255, 255, 255, 0.04);\n  border-color: rgba(255, 255, 255, 0.12);\n}\n.dc-privacy-head {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n.dc-privacy-title { font-size: 18px; font-weight: 800; }\n.dc-privacy-descs { margin: 0; padding-left: 20px; }\n.dc-privacy-desc { font-size: 14px; line-height: 1.6; }\n\n.dc-switch {\n  position: relative;\n  flex-shrink: 0;\n  width: 84px;\n  height: 38px;\n  border: 0;\n  border-radius: 999px;\n  background: #475569;\n  color: #fff;\n  cursor: pointer;\n  transition: background 0.2s ease, opacity 0.2s ease;\n}\n.dc-switch.on { background: #0c6b37; }\n.dc-switch:disabled { cursor: progress; }\n.dc-switch:focus-visible { outline: 3px solid rgba(18, 140, 74, 0.35); outline-offset: 2px; }\n.dc-switch-label {\n  position: absolute;\n  top: 50%;\n  right: 14px;\n  transform: translateY(-50%);\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.5px;\n}\n.dc-switch.on .dc-switch-label { right: auto; left: 14px; }\n.dc-switch-knob {\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n  transition: transform 0.2s ease;\n}\n.dc-switch.on .dc-switch-knob { transform: translateX(46px); }\n\n/* ===== Dark mode: page selector (Enquiries + Dashboard) =====\n   Bootstrap's pagination is white with blue links by default, which glares\n   on the dark table above it. Bootstrap 5.3 drives it entirely from these\n   variables, so redefining them restyles every page item at once. */\n.dark-theme .pagination {\n  --bs-pagination-color: #e5e7eb;\n  --bs-pagination-bg: #2a2d31;\n  --bs-pagination-border-color: rgba(255, 255, 255, 0.14);\n  --bs-pagination-hover-color: #fff;\n  --bs-pagination-hover-bg: #3a3f46;\n  --bs-pagination-hover-border-color: rgba(255, 255, 255, 0.22);\n  --bs-pagination-focus-color: #fff;\n  --bs-pagination-focus-bg: #3a3f46;\n  --bs-pagination-focus-box-shadow: 0 0 0 0.2rem rgba(57, 135, 229, 0.35);\n  --bs-pagination-active-color: #fff;\n  --bs-pagination-active-bg: #2f6fd6;\n  --bs-pagination-active-border-color: #2f6fd6;\n  --bs-pagination-disabled-color: rgba(255, 255, 255, 0.35);\n  --bs-pagination-disabled-bg: #232528;\n  --bs-pagination-disabled-border-color: rgba(255, 255, 255, 0.08);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
